<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card class="pa-5" style="position: absolute;">
      <v-card-title class="pb-0 px-5">
        <v-row>
          <v-spacer></v-spacer>
          <v-btn fab text x-small color="#00A99D" @click="closeDialog()">
            <v-icon >mdi-close</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>

      <v-card-text class="py-0 px-8">
        <v-form ref="save_form" v-model="valid" class="px-3">
          <v-row>
            <span class="font-16 text-000000">ฟอร์มเยี่ยมบ้าน อำเภอหาดใหญ่ Version 2.1</span>
          </v-row>
          <v-row>
            <v-col cols="12" xl="auto" lg="3" md="12" sm="12" class="d-flex d-flex-row pl-0 pb-0">
              <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">รหัสทะเบียนบ้าน</span>
              <v-row v-if="status !== 'detail'" no-gutters>
                <v-text-field
                  dense
                  solo
                  hide-details="auto"
                  v-model="data.house_registration_code"
                  :rules="status == 'see' ? [] : rules_input"
                  :readonly="status == 'see'"
                  v-mask="mask_houseReg"
                  @input="splitDatHouseReg"
                >
                  <template slot="label">
                    <span class="font-14">กรุณากรอกรหัสทะเบียนบ้าน</span>
                  </template>
                </v-text-field>
              </v-row>

              <v-row v-else no-gutters>
                <span class="mr-2 pt-2 font-16 text-000000">: {{ data.house_registration_code || '-' }}</span>
              </v-row>
            </v-col>

            <v-col cols="12" xl="auto" lg="3" md="4" sm="4" class="d-flex d-flex-row pl-0 pb-0">
              <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">บ้านเลขที่</span>
              <v-row v-if="status !== 'detail'" no-gutters>
                <v-text-field
                  dense
                  solo
                  hide-details="auto"
                  v-model="data.house_no"
                  :rules="status == 'see' ? [] : rules_input"
                  :readonly="status == 'see'"
                >
                  <template slot="label">
                    <span class="font-14">กรุณากรอกบ้านเลขที่</span>
                  </template>
                </v-text-field>
              </v-row>

              <v-row v-else no-gutters>
                <span class="mr-2 pt-2 font-16 text-000000">: {{ data.house_no || '-' }}</span>
              </v-row>
            </v-col>

            <v-col cols="12" xl="1" lg="3" md="4" sm="4" class="d-flex d-flex-row pl-0 pb-0">
              <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">หมู่ที่</span>
              <v-row v-if="status !== 'detail'" no-gutters>
                <v-text-field
                  dense
                  solo
                  hide-details="auto"
                  v-model="data.moo"
                  :rules="status == 'see' ? [] : rules_input"
                  :readonly="status == 'see'"
                >
                  <template slot="label">
                    <span class="font-14">กรุณากรอกหมู่ที่</span>
                  </template>
                </v-text-field>
              </v-row>

              <v-row v-else no-gutters>
                <span class="mr-2 pt-2 font-16 text-000000">: {{ data.moo || '-' }}</span>
              </v-row>
            </v-col>

            <v-col cols="12" xl="auto" lg="3" md="4" sm="4" class="d-flex d-flex-row pl-0 pb-0">
              <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ชุมชน</span>
              <v-row v-if="status !== 'detail'" no-gutters>
                <v-text-field
                  dense
                  solo
                  hide-details="auto"
                  v-model="data.community_name"
                  :rules="status == 'see' ? [] : rules_input"
                  :readonly="status == 'see'"
                >
                  <template slot="label">
                    <span class="font-14">กรุณากรอกชุมชน</span>
                  </template>
                </v-text-field>
              </v-row>

              <v-row v-else no-gutters>
                <span class="mr-2 pt-2 font-16 text-000000">: {{ data.community_name || '-' }}</span>
              </v-row>
            </v-col>

            <v-col cols="12" xl="auto" lg="3" md="4" sm="4" class="d-flex d-flex-row pl-0 pb-0">
              <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ถนน</span>
              <v-row v-if="status !== 'detail'" no-gutters>
                <v-text-field
                  dense
                  solo
                  hide-details="auto"
                  v-model="data.road"
                  :rules="status == 'see' ? [] : rules_input"
                  :readonly="status == 'see'"
                >
                  <template slot="label">
                    <span class="font-14">กรุณากรอกถนน</span>
                  </template>
                </v-text-field>
              </v-row>

              <v-row v-else no-gutters>
                <span class="mr-2 pt-2 font-16 text-000000">: {{ data.road || '-' }}</span>
              </v-row>
            </v-col>

            <v-col cols="12" xl="auto" lg="3" md="4" sm="4" class="d-flex d-flex-row pl-0 pb-0">
              <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ซอย</span>
              <v-row v-if="status !== 'detail'" no-gutters>
                <v-text-field
                  dense
                  solo
                  hide-details="auto"
                  v-model="data.soi"
                  :rules="status == 'see' ? [] : rules_input"
                  :readonly="status == 'see'"
                >
                  <template slot="label">
                    <span class="font-14">กรุณากรอกซอย</span>
                  </template>
                </v-text-field>
              </v-row>

              <v-row v-else no-gutters>
                <span class="mr-2 pt-2 font-16 text-000000">: {{ data.soi || '-' }}</span>
              </v-row>
            </v-col>
                
            <v-col cols="12" xl="auto" lg="3" md="4" sm="4" class="d-flex d-flex-row pl-0 pb-0">
              <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">เบอร์โทรศัพท์</span>
              <v-row v-if="status !== 'detail'" no-gutters>
                <v-text-field
                  dense
                  solo
                  hide-details="auto"
                  v-model="data.mobile"
                  :rules="status == 'see' ? [] : rules_input"
                  :readonly="status == 'see'"
                  @input="splitDatMobile()"
                  v-mask="[mask_mobile1, mask_mobile2]"
                >
                  <template slot="label">
                    <span class="font-14">กรุณากรอกเบอร์โทรศัพท์</span>
                  </template>
                </v-text-field>
              </v-row>

              <v-row v-else no-gutters>
                <span class="mr-2 pt-2 font-16 text-000000">: {{ data.mobile || '-' }}</span>
              </v-row>
            </v-col>
            
          </v-row>

          <v-row :class="display_vuetify == 'xs' ? 'mt-8 mb-5 pa-0':'mt-8 mb-5 pa-3'" style="border: 5px solid #00A99D;">
            <v-row class="ma-0">
              <v-col cols="12" xl="1" lg="1" md="2" sm="2" :class="display_vuetify == 'xs' ? 'pr-3' : 'py-1 px-2'">
                <v-sheet
                  v-if="display_vuetify !== 'xs'"
                  color="#00A99D"
                  style="height: 100%;"
                  width="80"
                >
                  <v-row no-gutters style="height: 100%;">
                    <v-col cols="12" align-self="center" align="center">
                    <span style="display: block;transform: rotate(-90deg);" class="font-18 text-white">เด็ก 0-14</span>
                    </v-col>
                  </v-row>
                </v-sheet>

                <v-sheet
                  v-else
                  color="#00A99D"
                  height="50"
                >
                  <v-row no-gutters style="height: 100%;">
                    <v-col cols="12" align-self="center" align="center">
                    <span class="font-16 text-white">เด็ก 0-14</span>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-col>
              <v-col cols="12" xl="10" lg="10" md="8" sm="8" :class="display_vuetify == 'xs' ? 'px-3' : display_vuetify == 'lg' ? 'px-3':'px-0' ">
                <v-row :class="display_vuetify == 'xs' ? 'pl-2' : 'px-0'">
                  <v-col cols="12" xl="3" lg="4" md="6" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">เลขบัตรประชาชน</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.under14.cardnum"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                        @input="splitDatID('id')"
                        v-mask="[mask_id]"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกเลขบัตรประชาชน</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.under14.cardnum || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="3" lg="4" md="6" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ชื่อ - นามสกุล</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.under14.fullname"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอก ชื่อ - นามสกุล</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.under14.fullname || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="2" lg="4" md="6" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">วันเดือนปีเกิด</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-menu
                        v-model="day_menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="350px"
                        min-width="auto"
                        bottom
                        left
                        :disabled="status == 'see'"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            solo
                            dense
                            append-icon="mdi-calendar-multiselect"
                            :value="displayDate()"
                            v-bind="attrs"
                            hide-details
                            v-on="on"
                            color="#00A99D"
                            item-color="teal darken-2"
                            :rules="status == 'see' ? [] : rules_input"
                            :readonly="status == 'see'"
                          >
                            <template slot="append">
                              <v-btn text icon width="10px" v-on="on" :readonly="status == 'see'">
                                <v-icon color="#00A99D"
                                  >mdi-calendar-multiselect</v-icon
                                >
                              </v-btn>
                            </template>

                            <template slot="label">
                              <span class="font-14">วัน/เดือน/ปี เกิด</span>
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          v-model="data.under14.birth_date"
                          :max="dateNow"
                          no-title
                          scrollable
                          locale="th"
                          @input="day_menu = false"
                          color="#00A99D"
                          ref="picker"
                          :readonly="status == 'see'"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="#00A99D" @click="clearDaySelect"
                            >ล้างค่า/clear</v-btn
                          >
                        </v-date-picker>
                      </v-menu>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ showDate(data.under14.birth_date) || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="2" lg="2" md="6" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">กรุ๊ปเลือด</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-select
                        solo
                        v-model="data.under14.blood"
                        :items="[
                          'A+',
                          'A-',
                          'B+',
                          'B-',
                          'O+',
                          'O-',
                          'AB+',
                          'AB-',
                        ]"
                        dense
                        color="#00A99D"
                        item-color="teal darken-2"
                        :menu-props="{ bottom: true, offsetY: true }"
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                      >
                        <template slot="append">
                          <v-btn text icon width="10px">
                            <v-icon color="#00A99D">mdi-chevron-down</v-icon>
                          </v-btn>
                        </template>
                        <template slot="label">
                          <span class="font-14">กรุณาเลือกกรุ๊ปเลือด</span>
                        </template>
                      </v-select>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.under14.blood || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="2" lg="2" md="6" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">น้ำหนัก</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.under14.weight"
                        :rules="status == 'see' ? [] : rules_input_num"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกน้ำหนัก</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.under14.weight || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="2" lg="2" md="6" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ส่วนสูง</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.under14.height"
                        :rules="status == 'see' ? [] : rules_input_num"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกส่วนสูง</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.under14.height || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="3" lg="6" md="6" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">สถานศึกษา</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.under14.school"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกสถานศึกษา</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.under14.school || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="2" lg="4" md="6" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ระดับ</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-select
                        solo
                        v-model="data.under14.level"
                        :items="[
                          'อนุบาล',
                          'ปฐมวัย',
                          'ประถมศึกษาตอนต้น',
                          'ประถมศึกษาตอนปลาย',
                          'มัธยมศึกษาตอนต้น',
                          'มัธยมศึกษาตอนปลาย'
                        ]"
                        dense
                        color="#00A99D"
                        item-color="teal darken-2"
                        :menu-props="{ bottom: true, offsetY: true }"
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                      >
                        <template slot="append">
                          <v-btn text icon width="10px">
                            <v-icon color="#00A99D">mdi-chevron-down</v-icon>
                          </v-btn>
                        </template>
                        <template slot="label">
                          <span class="font-14">กรุณาเลือกระดับ</span>
                        </template>
                      </v-select>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.under14.level || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="3" lg="4" md="6" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">โรคประจำตัว</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.under14.personal_disease"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกโรคประจำตัว</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.under14.personal_disease || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="2" lg="4" md="6" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">แพ้ยา</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.under14.allergic_medicine"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกแพ้ยา</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.under14.allergic_medicine || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="6" lg="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ศาสนา</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-checkbox
                        v-model="data.under14.religion.detail"
                        value="พุทธ"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5 ml-3"
                        @click="data.under14.religion.status = '1'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">พุทธ</span>
                        </template>
                      </v-checkbox>

                      <v-checkbox
                        v-model="data.under14.religion.detail"
                        value="อิสลาม"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1"
                        @click="data.under14.religion.status = '2'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">อิสลาม</span>
                        </template>
                      </v-checkbox>

                      <v-checkbox
                        v-model="data.under14.religion.detail"
                        value="คริสต์"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mx-5"
                        @click="data.under14.religion.status = '3'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">คริสต์</span>
                        </template>
                      </v-checkbox>

                      <v-checkbox
                        v-model="data.under14.religion.detail"
                        value="อื่นๆ"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-3"
                        @click="data.under14.religion.status = '4'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">อื่นๆ</span>
                        </template>
                      </v-checkbox>

                      <v-row v-if="data.under14.religion.detail == 'อื่นๆ'" no-gutters>
                        <v-text-field
                          dense
                          solo
                          hide-details="auto"
                          v-model="data.under14.religion.answer_title"
                          :rules="status == 'see' ? [] : rules_input"
                          :readonly="status == 'see'"
                        >
                          <template slot="label">
                            <span class="font-14">กรุณากรอกศาสนา</span>
                          </template>
                        </v-text-field>
                      </v-row>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.under14.religion.detail || '-' }}</span>
                      <span v-if="data.under14.religion.detail == 'อื่นๆ'" class="pt-2 mx-3 font-16 text-000000">ระบุ : {{ data.under14.religion.answer_title || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="6" lg="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ประเภทการอยู่อาศัย</span>

                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-checkbox
                        v-model="data.under14.living.answer_title"
                        value="Type 1"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5 ml-3"
                        @click="data.under14.living.status = '1'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">Type 1</span>
                        </template>
                      </v-checkbox>

                      <v-checkbox
                        v-model="data.under14.living.answer_title"
                        value="Type 2"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5 ml-3"
                        @click="data.under14.living.status = '2'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">Type 2</span>
                        </template>
                      </v-checkbox>

                      <v-checkbox
                        v-model="data.under14.living.answer_title"
                        value="ย้ายออก"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5 ml-3"
                        @click="data.under14.living.status = '3'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">ย้ายออก</span>
                        </template>
                      </v-checkbox>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.under14.living.answer_title || '-' }}</span>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" xl="1" lg="1" md="2" sm="2" class="px-0" align="center">
                <v-img
                  src="@/assets/icon/visit/image.svg"
                  height="100px"
                  width="100px"
                />
              </v-col>
            </v-row>

            <v-row class="ma-0">
              <v-col cols="12" xl="3" lg="3">
                <v-row no-gutters>
                  <v-col cols="12" class="pb-3 d-flex d-flex-row">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ข้อมูลบิดา ชื่อ - สกุล</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.under14.father_information.fullname"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกชื่อ - สกุล</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.under14.father_information.fullname || '-' }}</span>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="12" class="pb-3 d-flex d-flex-row">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">เลขบัตรประชาชน</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.under14.father_information.cardnum"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                        @input="splitDatID('id2')"
                        v-mask="[mask_id]"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกเลขบัตรประชาชน</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.under14.father_information.cardnum || '-' }}</span>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="12" class="pb-3 d-flex d-flex-row">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ข้อมูลมารดา ชื่อ - สกุล</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.under14.mother_information.fullname"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกชื่อ - สกุล</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.under14.mother_information.fullname || '-' }}</span>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="12" class="pb-3 d-flex d-flex-row">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">เลขบัตรประชาชน</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.under14.mother_information.cardnum"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                        @input="splitDatID('id3')"
                        v-mask="[mask_id]"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกเลขบัตรประชาชน</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.under14.mother_information.cardnum || '-' }}</span>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="12" class="pb-3 d-flex d-flex-row">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">น้ำหนักแรกเกิด</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.under14.birth_weight"
                        :rules="status == 'see' ? [] : rules_input_num"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกน้ำหนักแรกเกิด</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.under14.birth_weight || '-' }}</span>
                    </v-row>

                    <span class="ml-2 pt-2 font-16 text-000000" style="white-space: nowrap;">กรัม</span>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="12" class="pb-3 d-flex d-flex-row">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">กินนมแม่</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.under14.eat_mother_milk"
                        :rules="status == 'see' ? [] : rules_input_num"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกข้อมูล</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.under14.eat_mother_milk || '-' }}</span>
                    </v-row>

                    <span class="ml-2 pt-2 font-16 text-000000" style="white-space: nowrap;">เดือน</span>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="6" class="pb-3 d-flex d-flex-row">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">รอบศีรษะ</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.under14.around_head"
                        :rules="status == 'see' ? [] : rules_input_num"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกข้อมูล</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.under14.around_head || '-' }}</span>
                    </v-row>
                  </v-col>
                  <v-col cols="6" class="d-flex d-flex-row">
                    <span class="mx-2 pt-2 font-16 text-000000" style="white-space: nowrap;">สะดือ</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.under14.around_umbilical"
                        :rules="status == 'see' ? [] : rules_input_num"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกข้อมูล</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.under14.around_umbilical || '-' }}</span>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">พัฒนาการ</span>
                </v-row>
                <v-row v-if="status !== 'detail'" no-gutters>
                  <v-checkbox
                    v-model="data.under14.development.month.answer_title"
                    value="9 เดือน"
                    dense
                    hide-details="auto"
                    :rules="status == 'see' ? [] : rules_select"
                    :readonly="status == 'see'"
                    color="#00A99D"
                    class="mt-1 mr-5"
                    @click="data.under14.development.month.status = '1'"
                  >
                    <template slot="label">
                      <span class="font-16 text-000000">9 ด.</span>
                    </template>
                  </v-checkbox>

                  <v-checkbox
                    v-model="data.under14.development.month.answer_title"
                    value="18 เดือน"
                    dense
                    hide-details="auto"
                    :rules="status == 'see' ? [] : rules_select"
                    :readonly="status == 'see'"
                    color="#00A99D"
                    class="mt-1 mr-5"
                    @click="data.under14.development.month.status = '2'"
                  >
                    <template slot="label">
                      <span class="font-16 text-000000">18 ด.</span>
                    </template>
                  </v-checkbox>

                  <v-checkbox
                    v-model="data.under14.development.month.answer_title"
                    value="36 เดือน"
                    dense
                    hide-details="auto"
                    :rules="status == 'see' ? [] : rules_select"
                    :readonly="status == 'see'"
                    color="#00A99D"
                    class="mt-1 mr-5"
                    @click="data.under14.development.month.status = '3'"
                  >
                    <template slot="label">
                      <span class="font-16 text-000000">36 ด.</span>
                    </template>
                  </v-checkbox>

                  <v-checkbox
                    v-model="data.under14.development.month.answer_title"
                    value="42 เดือน"
                    dense
                    hide-details="auto"
                    :rules="status == 'see' ? [] : rules_select"
                    :readonly="status == 'see'"
                    color="#00A99D"
                    class="mt-1 mr-5"
                    @click="data.under14.development.month.status = '4'"
                  >
                    <template slot="label">
                      <span class="font-16 text-000000">42 ด.</span>
                    </template>
                  </v-checkbox>
                </v-row>
                <v-row v-else no-gutters>
                  <span class="pt-2 font-16 text-000000">{{ data.under14.development.month.answer_title || '-' }}</span>
                </v-row>

                <v-row v-if="status !== 'detail'" no-gutters>
                  <v-checkbox
                    v-model="data.under14.development.normality_status.answer_title"
                    value="ปกติ"
                    dense
                    hide-details="auto"
                    :rules="status == 'see' ? [] : rules_select"
                    :readonly="status == 'see'"
                    color="#00A99D"
                    class="mt-1 mr-5"
                    @click="data.under14.development.normality_status.status = '1'"
                  >
                    <template slot="label">
                      <span class="font-16 text-000000">ปกติ</span>
                    </template>
                  </v-checkbox>

                  <v-checkbox
                    v-model="data.under14.development.normality_status.answer_title"
                    value="ผิดปกติ"
                    dense
                    hide-details="auto"
                    :rules="status == 'see' ? [] : rules_select"
                    :readonly="status == 'see'"
                    color="#00A99D"
                    class="mt-1 mr-5"
                    @click="data.under14.development.normality_status.status = '2'"
                  >
                    <template slot="label">
                      <span class="font-16 text-000000">ผิดปกติ</span>
                    </template>
                  </v-checkbox>

                  <v-row no-gutters>
                    <v-col cols="12" class="d-flex d-flex-row">
                      <v-checkbox
                        v-model="data.under14.development.normality_status.answer_title"
                        value="ติดตาม"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                        @click="data.under14.development.normality_status.status = '3'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">ติดตาม</span>
                        </template>
                      </v-checkbox>

                      <v-row v-if="data.under14.development.normality_status.answer_title == 'ติดตาม'" no-gutters class="d-flex d-flex-row">
                        <v-text-field
                          v-model="data.under14.development.normality_status.more_answer_title"
                          dense
                          solo
                          hide-details="auto"
                          :rules="status == 'see' ? [] : rules_input"
                          :readonly="status == 'see'"
                        >
                          <template slot="label">
                            <span class="font-14">กรุณากรอกข้อมูล</span>
                          </template>
                        </v-text-field>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-row>
                <v-row v-else no-gutters>
                  <span class="pt-2 font-16 text-000000">{{ data.under14.development.normality_status.answer_title || '-' }}</span>
                  <span v-if="data.under14.development.normality_status.answer_title == 'ติดตาม'" class="pt-2 mx-3 font-16 text-000000">ระบุ : {{ data.under14.development.normality_status.more_answer_title || '-' }}</span>
                </v-row>
                
              </v-col>
              <v-col cols="12" xl="9" lg="9" class="d-flex d-flex-row">
                <v-row v-if="display_vuetify == 'xl' || display_vuetify == 'lg'" no-gutters style="display: block;">
                  <v-col cols="12" class="ma-0 pa-0 d-flex d-flex-row">
                    <v-row v-for="(i, n) in 3" :key="n" no-gutters class="ma-0 pa-0">
                      <v-col cols="4" class="pa-0 ma-0">
                        <v-sheet
                          color="#00A99D"
                          class="py-2 mx-1 my-0"
                          height="60px"
                        >
                          <v-row no-gutters style="height: 100%;">
                            <v-col cols="12" align-self="center" align="center">
                              <span class="font-18 text-white">วัคซีน</span>
                            </v-col>
                          </v-row>
                        </v-sheet>
                      </v-col>
                      <v-col cols="4" class="pa-0 ma-0">
                        <v-sheet
                          color="#00A99D"
                          class="py-2 mx-1 my-0"
                          height="60px"
                        >
                          <v-row no-gutters style="height: 100%;">
                            <v-col cols="12" align-self="center" align="center">
                              <span class="font-18 text-white">วันที่ฉีด</span>
                            </v-col>
                          </v-row>
                        </v-sheet>
                      </v-col>
                      <v-col cols="4" class="pa-0 ma-0">
                        <v-sheet
                          color="#00A99D"
                          class="py-2 mx-1 my-0"
                          height="60px"
                        >
                          <v-row no-gutters style="height: 100%;">
                            <v-col cols="12" align-self="center" align="center">
                              <span class="font-18 text-white">สถานที่</span>
                            </v-col>
                          </v-row>
                        </v-sheet>
                      </v-col>
                      <v-col cols="12" class="pa-0">
                        <v-row v-for="(item, index) in 6" :key="index" no-gutters class="mx-0 my-2">
                          <v-col cols="4" class="pa-0">
                            <v-sheet
                              height="60px"
                              :color="(index % 2) == 0 ? '#BFE9E6': '#E0F5F3'"
                              :class="(data.under14.vaccine[(6*n)+(index)].vaccine_name !== 'JE1/J11' && data.under14.vaccine[(6*n)+(index)].vaccine_name !== 'JE2/J12' && data.under14.vaccine[(6*n)+(index)].vaccine_name !== 'JE3/J11') || ((data.under14.vaccine[(6*n)+(index)].answer_title == '' || data.under14.vaccine[(6*n)+(index)].answer_title !== '') && status == 'detail') ? 'pt-4 pb-5 mx-1 my-0': 'py-1 mx-1 my-0'"
                            >
                              <v-row v-if="data.under14.vaccine[(6*n)+(index)].vaccine_name !== 'JE1/J11' && data.under14.vaccine[(6*n)+(index)].vaccine_name !== 'JE2/J12' && data.under14.vaccine[(6*n)+(index)].vaccine_name !== 'JE3/J11'" no-gutters style="height: 100%;">
                                <v-col cols="12" align-self="center" align="center">
                                  <span :class="display_vuetify == 'xl' ? 'font-16 text-000000' : 'font-14 text-000000'">{{ data.under14.vaccine[(6*n)+(index)].vaccine_name }}</span>
                                </v-col>
                              </v-row>

                              <v-row v-else-if="data.under14.vaccine[(6*n)+(index)].vaccine_name == 'JE1/J11'" no-gutters class="ma-0 pt-1 pb-0">
                                <v-row v-if="status !== 'detail'" no-gutters>
                                  <v-col cols="12" class="pa-0" align-self="center" align="center">
                                    <v-checkbox
                                      v-model="data.under14.vaccine[(6*n)+(index)].answer_title"
                                      value="JE1"
                                      dense
                                      hide-details="auto"
                                      :rules="status == 'see' ? [] : rules_select"
                                      :readonly="status == 'see'"
                                      color="#00A99D"
                                      style="display: inline-flex;"
                                      class="ma-0 pa-0"
                                      @click="data.under14.vaccine[(6*n)+(index)].status = '1'"
                                    >
                                      <template slot="label">
                                        <span class="font-16 text-000000">JE1/</span>
                                      </template>
                                    </v-checkbox>
                                  </v-col>
                                  <v-col cols="12" class="pa-0" align-self="center" align="center">
                                    <v-checkbox
                                      v-model="data.under14.vaccine[(6*n)+(index)].answer_title"
                                      value="J11"
                                      dense
                                      hide-details="auto"
                                      :rules="status == 'see' ? [] : rules_select"
                                      :readonly="status == 'see'"
                                      color="#00A99D"
                                      style="display: inline-flex;"
                                      class="ma-0 pa-0"
                                      @click="data.under14.vaccine[(6*n)+(index)].status = '2'"
                                    >
                                      <template slot="label">
                                        <span class="pr-2 font-16 text-000000">J11</span>
                                      </template>
                                    </v-checkbox>
                                  </v-col>
                                </v-row>

                                <v-row v-else no-gutters>
                                  <v-col cols="12" align-self="center" align="center">
                                    <span class="font-16 text-000000">{{ data.under14.vaccine[(6*n)+(index)].answer_title || 'JE1/J11' }}</span>
                                  </v-col>
                                </v-row>
                              </v-row>

                              <v-row v-else-if="data.under14.vaccine[(6*n)+(index)].vaccine_name == 'JE2/J12'" no-gutters class="ma-0 pt-1 pb-0">
                                <v-row v-if="status !== 'detail'" no-gutters>
                                  <v-col cols="12" class="pa-0" align-self="center" align="center">
                                    <v-checkbox
                                      v-model="data.under14.vaccine[(6*n)+(index)].answer_title"
                                      value="JE2"
                                      dense
                                      hide-details="auto"
                                      :rules="status == 'see' ? [] : rules_select"
                                      :readonly="status == 'see'"
                                      color="#00A99D"
                                      style="display: inline-flex;"
                                      class="ma-0 pa-0"
                                      @click="data.under14.vaccine[(6*n)+(index)].status = '1'"
                                    >
                                      <template slot="label">
                                        <span class="font-16 text-000000">JE2/</span>
                                      </template>
                                    </v-checkbox>
                                  </v-col>
                                  <v-col cols="12" class="pa-0" align-self="center" align="center">
                                    <v-checkbox
                                      v-model="data.under14.vaccine[(6*n)+(index)].answer_title"
                                      value="J12"
                                      dense
                                      hide-details="auto"
                                      :rules="status == 'see' ? [] : rules_select"
                                      :readonly="status == 'see'"
                                      color="#00A99D"
                                      style="display: inline-flex;"
                                      class="ma-0 pa-0"
                                      @click="data.under14.vaccine[(6*n)+(index)].status = '2'"
                                    >
                                      <template slot="label">
                                        <span class="pr-2 font-16 text-000000">J12</span>
                                      </template>
                                    </v-checkbox>
                                  </v-col>
                                </v-row>
                                
                                <v-row v-else no-gutters>
                                  <v-col cols="12" align-self="center" align="center">
                                    <span class="font-16 text-000000">{{ data.under14.vaccine[(6*n)+(index)].answer_title || 'JE2/J12' }}</span>
                                  </v-col>
                                </v-row>
                              </v-row>

                              <v-row v-else-if="data.under14.vaccine[(6*n)+(index)].vaccine_name == 'JE3/J11'" no-gutters class="ma-0 pt-1 pb-0">
                                <v-row v-if="status !== 'detail'" no-gutters>
                                  <v-col cols="12" class="pa-0" align-self="center" align="center">
                                    <v-checkbox
                                      v-model="data.under14.vaccine[(6*n)+(index)].answer_title"
                                      value="JE3"
                                      dense
                                      hide-details="auto"
                                      :rules="status == 'see' ? [] : rules_select"
                                      :readonly="status == 'see'"
                                      color="#00A99D"
                                      style="display: inline-flex;"
                                      class="ma-0 pa-0"
                                      @click="data.under14.vaccine[(6*n)+(index)].status = '1'"
                                    >
                                      <template slot="label">
                                        <span class="font-16 text-000000">JE3/</span>
                                      </template>
                                    </v-checkbox>
                                  </v-col>
                                  <v-col cols="12" class="pa-0" align-self="center" align="center">
                                    <v-checkbox
                                      v-model="data.under14.vaccine[(6*n)+(index)].answer_title"
                                      value="J11"
                                      dense
                                      hide-details="auto"
                                      :rules="status == 'see' ? [] : rules_select"
                                      :readonly="status == 'see'"
                                      color="#00A99D"
                                      style="display: inline-flex;"
                                      class="ma-0 pa-0"
                                      @click="data.under14.vaccine[(6*n)+(index)].status = '2'"
                                    >
                                      <template slot="label">
                                        <span class="pr-2 font-16 text-000000">J11</span>
                                      </template>
                                    </v-checkbox>
                                  </v-col>
                                </v-row>

                                <v-row v-else no-gutters>
                                  <v-col cols="12" align-self="center" align="center">
                                    <span class="font-16 text-000000">{{ data.under14.vaccine[(6*n)+(index)].answer_title || 'JE3/J11' }}</span>
                                  </v-col>
                                </v-row>
                                
                              </v-row>
                            </v-sheet>
                          </v-col>
                          <v-col cols="4" class="pa-0">
                            <v-sheet
                              height="60px"
                              :color="(index % 2) == 0 ? '#BFE9E6': '#E0F5F3'"
                              class="pa-3 mx-1 my-0"
                            >
                              <v-row v-if="status !== 'detail'" no-gutters style="height: 100%;">
                                <v-col cols="12" align-self="center" align="center">
                                  <v-menu
                                    transition="scale-transition"
                                    offset-y
                                    max-width="350px"
                                    min-width="auto"
                                    bottom
                                    left
                                    :disabled="status == 'see'"
                                    :close-on-content-click="false"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        solo
                                        dense
                                        append-icon="mdi-calendar-multiselect"
                                        :value="displayDate1((6*n)+(index))"
                                        v-bind="attrs"
                                        hide-details
                                        v-on="on"
                                        color="#00A99D"
                                        item-color="teal darken-2"
                                        :rules="status == 'see' ? [] : rules_input"
                                        :readonly="status == 'see'"
                                        class="font-12"
                                      >
                                        <template slot="append">
                                          <v-btn text icon small width="10px" v-on="on" :readonly="status == 'see'">
                                            <v-icon color="#00A99D"
                                              >mdi-calendar-multiselect</v-icon
                                            >
                                          </v-btn>
                                        </template>

                                        <template slot="label">
                                          <span class="font-14">วันที่ฉีด</span>
                                        </template>
                                      </v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="data.under14.vaccine[(6*n)+(index)].date"
                                      no-title
                                      scrollable
                                      locale="th"
                                      color="#00A99D"
                                      ref="picker"
                                      :readonly="status == 'see'"
                                    >
                                    </v-date-picker>
                                  </v-menu>
                                </v-col>
                              </v-row>

                              <v-row v-else no-gutters style="height: 100%;">
                                <v-col cols="12" align-self="center" align="center" class="pt-2 pb-1">
                                  <span :class="display_vuetify == 'xl' ? 'font-14 text-000000' : 'font-11 text-000000'">{{ showDate(data.under14.vaccine[(6*n)+(index)].date) || '-' }}</span>
                                </v-col>
                              </v-row>
                            </v-sheet>
                          </v-col>
                          <v-col cols="4" class="pa-0">
                            <v-sheet
                              height="60px"
                              :color="(index % 2) == 0 ? '#BFE9E6': '#E0F5F3'"
                              class="pa-3 mx-1 my-0"
                            >
                              <v-row v-if="status !== 'detail'" no-gutters style="height: 100%;">
                                <v-col cols="12" align-self="center" align="center">
                                  <v-text-field
                                    v-model="data.under14.vaccine[(6*n)+(index)].location"
                                    dense
                                    solo
                                    hide-details="auto"
                                    :rules="status == 'see' ? [] : rules_input"
                                    :readonly="status == 'see'"
                                  >
                                    <template slot="label">
                                      <span class="font-14">สถานที่</span>
                                    </template>
                                  </v-text-field>
                                </v-col>
                              </v-row>

                              <v-row v-else no-gutters style="height: 100%;">
                                <v-col cols="12" align-self="center" align="center" class="pt-2 pb-1">
                                  <span class="font-14 text-000000">{{ data.under14.vaccine[(6*n)+(index)].location || '-' }}</span>
                                </v-col>
                              </v-row>
                            </v-sheet>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row v-else-if="display_vuetify == 'md' || display_vuetify == 'sm'" no-gutters>
                  <v-col cols="12" xl="4" lg="4">
                    <v-row no-gutters>
                      <v-col cols="4" class="pa-0">
                        <v-sheet
                          color="#00A99D"
                          class="py-3 mx-1"
                        >
                          <v-row no-gutters style="height: 100%;">
                            <v-col cols="12" align-self="center" align="center">
                              <span class="font-18 text-white">วัคซีน</span>
                            </v-col>
                          </v-row>
                        </v-sheet>
                      </v-col>
                      <v-col cols="4" class="pa-0">
                        <v-sheet
                          color="#00A99D"
                          class="py-3 mx-1"
                        >
                          <v-row no-gutters style="height: 100%;">
                            <v-col cols="12" align-self="center" align="center">
                              <span class="font-18 text-white">วันที่ฉีด</span>
                            </v-col>
                          </v-row>
                        </v-sheet>
                      </v-col>
                      <v-col cols="4" class="pa-0">
                        <v-sheet
                          color="#00A99D"
                          class="py-3 mx-1"
                        >
                          <v-row no-gutters style="height: 100%;">
                            <v-col cols="12" align-self="center" align="center">
                              <span class="font-18 text-white">สถานที่</span>
                            </v-col>
                          </v-row>
                        </v-sheet>
                      </v-col>
                    </v-row>
                    <v-row v-for="(item, index) in data.under14.vaccine" :key="index" no-gutters class="mt-1">
                      <v-col cols="4" class="pa-0">
                        <v-sheet
                          :color="(index % 2) == 0 ? '#BFE9E6': '#E0F5F3'"
                          :class="(data.under14.vaccine[index].vaccine_name !== 'JE1/J11' && data.under14.vaccine[index].vaccine_name !== 'JE2/J12' && data.under14.vaccine[index].vaccine_name !== 'JE3/J11') || ((data.under14.vaccine[index].answer_title == '' || data.under14.vaccine[index].answer_title !== '') && status == 'detail') ? 'pt-4 pb-5 mx-1 my-0': 'py-1 mx-1 my-0'"
                        >
                          <v-row v-if="item.vaccine_name !== 'JE1/J11' && item.vaccine_name !== 'JE2/J12' && item.vaccine_name !== 'JE3/J11'" no-gutters style="height: 100%;">
                            <v-col cols="12" align-self="center" align="center">
                              <span class="font-16 text-000000">{{ item.vaccine_name }}</span>
                            </v-col>
                          </v-row>

                          <v-row v-else-if="item.vaccine_name == 'JE1/J11'" no-gutters class="ma-0 pt-1 pb-0">
                            <v-row v-if="status !== 'detail'" no-gutters>
                              <v-col cols="12" class="pa-0" align-self="center" align="center">
                                <v-checkbox
                                  v-model="data.under14.vaccine[index].answer_title"
                                  value="JE1"
                                  dense
                                  hide-details="auto"
                                  :rules="status == 'see' ? [] : rules_select"
                                  :readonly="status == 'see'"
                                  color="#00A99D"
                                  style="display: inline-flex;"
                                  class="ma-0 pa-0"
                                  @click="data.under14.vaccine[index].status = '1'"
                                >
                                  <template slot="label">
                                    <span class="font-16 text-000000">JE1/</span>
                                  </template>
                                </v-checkbox>
                              </v-col>
                              <v-col cols="12" class="pa-0" align-self="center" align="center">
                                <v-checkbox
                                  v-model="data.under14.vaccine[index].answer_title"
                                  value="J11"
                                  dense
                                  hide-details="auto"
                                  :rules="status == 'see' ? [] : rules_select"
                                  :readonly="status == 'see'"
                                  color="#00A99D"
                                  style="display: inline-flex;"
                                  class="ma-0 pa-0"
                                  @click="data.under14.vaccine[index].status = '2'"
                                >
                                  <template slot="label">
                                    <span class="pr-2 font-16 text-000000">J11</span>
                                  </template>
                                </v-checkbox>
                              </v-col>
                            </v-row>

                            <v-row v-else no-gutters>
                              <v-col cols="12" align-self="center" align="center">
                                <span class="font-16 text-000000">{{ data.under14.vaccine[index].answer_title || 'JE1/J11' }}</span>
                              </v-col>
                            </v-row>
                          </v-row>

                          <v-row v-else-if="item.vaccine_name == 'JE2/J12'" no-gutters class="ma-0 pt-1 pb-0">
                            <v-row v-if="status !== 'detail'" no-gutters>
                              <v-col cols="12" class="pa-0" align-self="center" align="center">
                                <v-checkbox
                                  v-model="data.under14.vaccine[index].answer_title"
                                  value="JE2"
                                  dense
                                  hide-details="auto"
                                  :rules="status == 'see' ? [] : rules_select"
                                  :readonly="status == 'see'"
                                  color="#00A99D"
                                  style="display: inline-flex;"
                                  class="ma-0 pa-0"
                                  @click="data.under14.vaccine[index].status = '1'"
                                >
                                  <template slot="label">
                                    <span class="font-16 text-000000">JE2/</span>
                                  </template>
                                </v-checkbox>
                              </v-col>
                              <v-col cols="12" class="pa-0" align-self="center" align="center">
                                <v-checkbox
                                  v-model="data.under14.vaccine[index].answer_title"
                                  value="J12"
                                  dense
                                  hide-details="auto"
                                  :rules="status == 'see' ? [] : rules_select"
                                  :readonly="status == 'see'"
                                  color="#00A99D"
                                  style="display: inline-flex;"
                                  class="ma-0 pa-0"
                                  @click="data.under14.vaccine[index].status = '2'"
                                >
                                  <template slot="label">
                                    <span class="pr-2 font-16 text-000000">J12</span>
                                  </template>
                                </v-checkbox>
                              </v-col>
                            </v-row>

                            <v-row v-else no-gutters>
                              <v-col cols="12" align-self="center" align="center">
                                <span class="font-16 text-000000">{{ data.under14.vaccine[index].answer_title || 'JE2/J12' }}</span>
                              </v-col>
                            </v-row>
                          </v-row>

                          <v-row v-else-if="item.vaccine_name == 'JE3/J11'" no-gutters class="ma-0 pt-1 pb-0">
                            <v-row v-if="status !== 'detail'" no-gutters>
                              <v-col cols="12" class="pa-0" align-self="center" align="center">
                                <v-checkbox
                                  v-model="data.under14.vaccine[index].answer_title"
                                  value="JE3"
                                  dense
                                  hide-details="auto"
                                  :rules="status == 'see' ? [] : rules_select"
                                  :readonly="status == 'see'"
                                  color="#00A99D"
                                  style="display: inline-flex;"
                                  class="ma-0 pa-0"
                                  @click="data.under14.vaccine[index].status = '1'"
                                >
                                  <template slot="label">
                                    <span class="font-16 text-000000">JE3/</span>
                                  </template>
                                </v-checkbox>
                              </v-col>
                              <v-col cols="12" class="pa-0" align-self="center" align="center">
                                <v-checkbox
                                  v-model="data.under14.vaccine[index].answer_title"
                                  value="J11"
                                  dense
                                  hide-details="auto"
                                  :rules="status == 'see' ? [] : rules_select"
                                  :readonly="status == 'see'"
                                  color="#00A99D"
                                  style="display: inline-flex;"
                                  class="ma-0 pa-0"
                                  @click="data.under14.vaccine[index].status = '2'"
                                >
                                  <template slot="label">
                                    <span class="pr-2 font-16 text-000000">J11</span>
                                  </template>
                                </v-checkbox>
                              </v-col>
                            </v-row>

                            <v-row v-else no-gutters>
                              <v-col cols="12" align-self="center" align="center">
                                <span class="font-16 text-000000">{{ data.under14.vaccine[index].answer_title || 'JE3/J11' }}</span>
                              </v-col>
                            </v-row>
                          </v-row>
                        </v-sheet>
                      </v-col>
                      <v-col cols="4" class="pa-0">
                        <v-sheet
                          :color="(index % 2) == 0 ? '#BFE9E6': '#E0F5F3'"
                          class="pa-3 mx-1 my-0"
                        >
                          <v-row v-if="status !== 'detail'" no-gutters style="height: 100%;">
                            <v-col cols="12" align-self="center" align="center">
                              <v-menu
                                transition="scale-transition"
                                offset-y
                                max-width="350px"
                                min-width="auto"
                                bottom
                                left
                                :disabled="status == 'see'"
                                :close-on-content-click="false"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    solo
                                    dense
                                    append-icon="mdi-calendar-multiselect"
                                    :value="displayDate1(index)"
                                    v-bind="attrs"
                                    hide-details
                                    v-on="on"
                                    color="#00A99D"
                                    item-color="teal darken-2"
                                    :rules="status == 'see' ? [] : rules_input"
                                    :readonly="status == 'see'"
                                  >
                                    <template slot="append">
                                      <v-btn text icon small width="10px" v-on="on" :readonly="status == 'see'">
                                        <v-icon color="#00A99D"
                                          >mdi-calendar-multiselect</v-icon
                                        >
                                      </v-btn>
                                    </template>

                                    <template slot="label">
                                      <span class="font-14">วันที่ฉีด</span>
                                    </template>
                                  </v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="data.under14.vaccine[index].date"
                                  no-title
                                  scrollable
                                  locale="th"
                                  color="#00A99D"
                                  ref="picker"
                                  :readonly="status == 'see'"
                                >
                                </v-date-picker>
                              </v-menu>
                            </v-col>
                          </v-row>

                          <v-row v-else no-gutters style="height: 100%;">
                            <v-col cols="12" align-self="center" align="center" class="py-2">
                              <span class="font-14 text-000000">{{ showDate(data.under14.vaccine[index].date) || '-' }}</span>
                            </v-col>
                          </v-row>
                        </v-sheet>
                      </v-col>
                      <v-col cols="4" class="pa-0">
                        <v-sheet
                          :color="(index % 2) == 0 ? '#BFE9E6': '#E0F5F3'"
                          class="pa-3 mx-1 my-0"
                        >
                          <v-row v-if="status !== 'detail'" no-gutters style="height: 100%;">
                            <v-col cols="12" align-self="center" align="center">
                              <v-text-field
                                v-model="data.under14.vaccine[index].location"
                                dense
                                solo
                                hide-details="auto"
                                :rules="status == 'see' ? [] : rules_input"
                                :readonly="status == 'see'"
                              >
                                <template slot="label">
                                  <span class="font-14">สถานที่</span>
                                </template>
                              </v-text-field>
                            </v-col>
                          </v-row>

                          <v-row v-else no-gutters style="height: 100%;">
                            <v-col cols="12" align-self="center" align="center" class="py-2">
                              <span class="font-14 text-000000">{{ data.under14.vaccine[index].location || '-' }}</span>
                            </v-col>
                          </v-row>
                        </v-sheet>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row v-else no-gutters>
                  <v-col cols="12">
                    <v-row v-for="(item, index) in data.under14.vaccine" :key="index" no-gutters class="my-0">
                      <v-col cols="4">
                        <v-sheet
                          color="#00A99D"
                          class="py-4 ma-1"
                        >
                          <v-row no-gutters style="height: 100%;">
                            <v-col cols="12" align-self="center" align="center">
                              <span class="font-16 text-white">วัคซีน</span>
                            </v-col>
                          </v-row>
                        </v-sheet>
                      </v-col>
                      <v-col cols="8">
                        <v-sheet
                          color="#BFE9E6"
                          :class="(data.under14.vaccine[index].vaccine_name !== 'JE1/J11' && data.under14.vaccine[index].vaccine_name !== 'JE2/J12' && data.under14.vaccine[index].vaccine_name !== 'JE3/J11') || ((data.under14.vaccine[index].answer_title == '' || data.under14.vaccine[index].answer_title !== '') && status == 'detail') ? 'pt-4 pb-5 ma-1': 'py-0 ma-1'"
                        >
                          <v-row v-if="item.vaccine_name !== 'JE1/J11' && item.vaccine_name !== 'JE2/J12' && item.vaccine_name !== 'JE3/J11'" no-gutters style="height: 100%;">
                            <v-col cols="12" align-self="center" align="center">
                              <span class="font-16 text-000000">{{ item.vaccine_name }}</span>
                            </v-col>
                          </v-row>

                          <v-row v-else-if="item.vaccine_name == 'JE1/J11'" no-gutters class="ma-0 pt-1 pb-0">
                            <v-row v-if="status !== 'detail'" no-gutters>
                              <v-col cols="12" class="pa-0" align-self="center" align="center">
                                <v-checkbox
                                  v-model="data.under14.vaccine[index].answer_title"
                                  value="JE1"
                                  dense
                                  hide-details="auto"
                                  :rules="status == 'see' ? [] : rules_select"
                                  :readonly="status == 'see'"
                                  color="#00A99D"
                                  style="display: inline-flex;"
                                  class="ma-0 pa-0"
                                  @click="data.under14.vaccine[index].status = '1'"
                                >
                                  <template slot="label">
                                    <span class="font-16 text-000000">JE1/</span>
                                  </template>
                                </v-checkbox>
                              </v-col>
                              <v-col cols="12" class="pa-0" align-self="center" align="center">
                                <v-checkbox
                                  v-model="data.under14.vaccine[index].answer_title"
                                  value="J11"
                                  dense
                                  hide-details="auto"
                                  :rules="status == 'see' ? [] : rules_select"
                                  :readonly="status == 'see'"
                                  color="#00A99D"
                                  style="display: inline-flex;"
                                  class="ma-0 pa-0"
                                  @click="data.under14.vaccine[index].status = '2'"
                                >
                                  <template slot="label">
                                    <span class="pr-2 font-16 text-000000">J11</span>
                                  </template>
                                </v-checkbox>
                              </v-col>
                            </v-row>

                            <v-row v-else no-gutters>
                              <v-col cols="12" align-self="center" align="center">
                                <span class="font-16 text-000000">{{ data.under14.vaccine[index].answer_title || 'JE1/J11' }}</span>
                              </v-col>
                            </v-row>
                          </v-row>

                          <v-row v-else-if="item.vaccine_name == 'JE2/J12'" no-gutters class="ma-0 pt-1 pb-0">
                            <v-row v-if="status !== 'detail'" no-gutters>
                              <v-col cols="12" class="pa-0" align-self="center" align="center">
                                <v-checkbox
                                  v-model="data.under14.vaccine[index].answer_title"
                                  value="JE2"
                                  dense
                                  hide-details="auto"
                                  :rules="status == 'see' ? [] : rules_select"
                                  :readonly="status == 'see'"
                                  color="#00A99D"
                                  style="display: inline-flex;"
                                  class="ma-0 pa-0"
                                  @click="data.under14.vaccine[index].status = '1'"
                                >
                                  <template slot="label">
                                    <span class="font-16 text-000000">JE2/</span>
                                  </template>
                                </v-checkbox>
                              </v-col>
                              <v-col cols="12" class="pa-0" align-self="center" align="center">
                                <v-checkbox
                                  v-model="data.under14.vaccine[index].answer_title"
                                  value="J12"
                                  dense
                                  hide-details="auto"
                                  :rules="status == 'see' ? [] : rules_select"
                                  :readonly="status == 'see'"
                                  color="#00A99D"
                                  style="display: inline-flex;"
                                  class="ma-0 pa-0"
                                  @click="data.under14.vaccine[index].status = '2'"
                                >
                                  <template slot="label">
                                    <span class="pr-2 font-16 text-000000">J12</span>
                                  </template>
                                </v-checkbox>
                              </v-col>
                            </v-row>

                            <v-row v-else no-gutters>
                              <v-col cols="12" align-self="center" align="center">
                                <span class="font-16 text-000000">{{ data.under14.vaccine[index].answer_title || 'JE2/J12' }}</span>
                              </v-col>
                            </v-row>
                          </v-row>

                          <v-row v-else-if="item.vaccine_name == 'JE3/J11'" no-gutters class="ma-0 pt-1 pb-0">
                            <v-row v-if="status !== 'detail'" no-gutters>
                              <v-col cols="12" class="pa-0" align-self="center" align="center">
                                <v-checkbox
                                  v-model="data.under14.vaccine[index].answer_title"
                                  value="JE3"
                                  dense
                                  hide-details="auto"
                                  :rules="status == 'see' ? [] : rules_select"
                                  :readonly="status == 'see'"
                                  color="#00A99D"
                                  style="display: inline-flex;"
                                  class="ma-0 pa-0"
                                  @click="data.under14.vaccine[index].status = '1'"
                                >
                                  <template slot="label">
                                    <span class="font-16 text-000000">JE3/</span>
                                  </template>
                                </v-checkbox>
                              </v-col>
                              <v-col cols="12" class="pa-0" align-self="center" align="center">
                                <v-checkbox
                                  v-model="data.under14.vaccine[index].answer_title"
                                  value="J11"
                                  dense
                                  hide-details="auto"
                                  :rules="status == 'see' ? [] : rules_select"
                                  :readonly="status == 'see'"
                                  color="#00A99D"
                                  style="display: inline-flex;"
                                  class="ma-0 pa-0"
                                  @click="data.under14.vaccine[index].status = '2'"
                                >
                                  <template slot="label">
                                    <span class="pr-2 font-16 text-000000">J11</span>
                                  </template>
                                </v-checkbox>
                              </v-col>
                            </v-row>

                            <v-row v-else no-gutters>
                              <v-col cols="12" align-self="center" align="center">
                                <span class="font-16 text-000000">{{ data.under14.vaccine[index].answer_title || 'JE3/J11' }}</span>
                              </v-col>
                            </v-row>
                          </v-row>
                        </v-sheet>
                      </v-col>
                      <v-col cols="4">
                        <v-sheet
                          color="#00A99D"
                          class="py-4 ma-1"
                        >
                          <v-row no-gutters style="height: 100%;">
                            <v-col cols="12" align-self="center" align="center">
                              <span class="font-16 text-white">วันที่ฉีด</span>
                            </v-col>
                          </v-row>
                        </v-sheet>
                      </v-col>
                      <v-col cols="8">
                        <v-sheet
                          color="#E0F5F3"
                          class="pa-2 ma-1"
                        >
                          <v-row v-if="status !== 'detail'" no-gutters style="height: 100%;">
                            <v-col cols="12" align-self="center" align="center">
                              <v-menu
                                transition="scale-transition"
                                offset-y
                                max-width="350px"
                                min-width="auto"
                                bottom
                                left
                                :disabled="status == 'see'"
                                :close-on-content-click="false"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    solo
                                    dense
                                    append-icon="mdi-calendar-multiselect"
                                    :value="displayDate1(index)"
                                    v-bind="attrs"
                                    hide-details
                                    v-on="on"
                                    color="#00A99D"
                                    item-color="teal darken-2"
                                    :rules="status == 'see' ? [] : rules_input"
                                    :readonly="status == 'see'"
                                  >
                                    <template slot="append">
                                      <v-btn text icon small width="10px" v-on="on" :readonly="status == 'see'">
                                        <v-icon color="#00A99D"
                                          >mdi-calendar-multiselect</v-icon
                                        >
                                      </v-btn>
                                    </template>

                                    <template slot="label">
                                      <span class="font-14">วันที่ฉีด</span>
                                    </template>
                                  </v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="data.under14.vaccine[index].date"
                                  no-title
                                  scrollable
                                  locale="th"
                                  color="#00A99D"
                                  ref="picker"
                                  :readonly="status == 'see'"
                                >
                                </v-date-picker>
                              </v-menu>
                            </v-col>
                          </v-row>

                          <v-row v-else no-gutters style="height: 100%;">
                            <v-col cols="12" align-self="center" align="center" class="py-2">
                              <span class="font-14 text-000000">{{ showDate(data.under14.vaccine[index].date) || '-' }}</span>
                            </v-col>
                          </v-row>
                        </v-sheet>
                      </v-col>
                      <v-col cols="4">
                        <v-sheet
                          color="#00A99D"
                          class="py-4 ma-1"
                        >
                          <v-row no-gutters style="height: 100%;">
                            <v-col cols="12" align-self="center" align="center">
                              <span class="font-16 text-white">สถานที่</span>
                            </v-col>
                          </v-row>
                        </v-sheet>
                      </v-col>
                      <v-col cols="8">
                        <v-sheet
                          color="#BFE9E6"
                          class="pa-2 ma-1"
                        >
                          <v-row v-if="status !== 'detail'" no-gutters style="height: 100%;">
                            <v-col cols="12" align-self="center" align="center">
                              <v-text-field
                                v-model="data.under14.vaccine[index].location"
                                dense
                                solo
                                hide-details="auto"
                                :rules="status == 'see' ? [] : rules_input"
                                :readonly="status == 'see'"
                              >
                                <template slot="label">
                                  <span class="font-14">สถานที่</span>
                                </template>
                              </v-text-field>
                            </v-col>
                          </v-row>

                          <v-row v-else no-gutters style="height: 100%;">
                            <v-col cols="12" align-self="center" align="center" class="py-2">
                              <span class="font-14 text-000000">{{ data.under14.vaccine[index].location || '-' }}</span>
                            </v-col>
                          </v-row>
                        </v-sheet>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              
              <v-col cols="12">
                <v-row no-gutters>
                  <v-col cols="12" xl="2" lg="2" md="4" sm="4" class="d-flex d-flex-row pl-0 pb-3">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ฟันน้ำนม</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.under14.milk_tooth"
                        :rules="status == 'see' ? [] : rules_input_num"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกข้อมูล</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.under14.milk_tooth || '-' }}</span>
                    </v-row>

                    <span class="mx-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ซี่</span>
                  </v-col>

                  <v-col cols="12" xl="2" lg="2" md="4" sm="4" class="d-flex d-flex-row pl-0 pb-3">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ฟันแท้</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.under14.real_tooth"
                        :rules="status == 'see' ? [] : rules_input_num"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกข้อมูล</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.under14.real_tooth || '-' }}</span>
                    </v-row>

                    <span class="mx-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ซี่</span>
                  </v-col>

                  <v-col cols="12" xl="2" lg="2" md="4" sm="4" class="d-flex d-flex-row pl-0 pb-3">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ฟันผุ</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.under14.toothless"
                        :rules="status == 'see' ? [] : rules_input_num"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกข้อมูล</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.under14.toothless || '-' }}</span>
                    </v-row>

                    <span class="mx-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ซี่</span>
                  </v-col>
                  
                  <v-col cols="12" xl="2" lg="2" md="4" sm="4" class="d-flex d-flex-row pl-0 pb-3">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">เหงือก</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.under14.gills"
                        :rules="status == 'see' ? [] : rules_input_num"
                        :readonly="status == 'see'"
                        class="mr-2"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกข้อมูล</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.under14.gills || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="2" lg="2" md="4" sm="4" class="d-flex d-flex-row pl-0 pb-3">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ฟลูออไรด์</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.under14.fluoride"
                        :rules="status == 'see' ? [] : rules_input_num"
                        :readonly="status == 'see'"
                        class="mr-2"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกข้อมูล</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.under14.fluoride || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="2" lg="2" md="4" sm="4" class="d-flex d-flex-row pl-0 pb-3">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">หลุมร่องฟัน</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.under14.hole_tooth"
                        :rules="status == 'see' ? [] : rules_input_num"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกข้อมูล</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.under14.hole_tooth || '-' }}</span>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-row>

          <v-row :class="display_vuetify == 'xs' ? 'mt-5 mb-8 pb-5 px-1':'my-5 px-5 pt-3 pb-5'" style="border: 5px solid #00A99D;">
            <v-row class="ma-0">
              <v-col cols="12" xl="1" lg="1" md="2" sm="2" :class="display_vuetify == 'xs' ? 'pr-3' : 'pa-1'">
                <v-sheet
                  v-if="display_vuetify !== 'xs'"
                  color="#00A99D"
                  style="height: 100%;"
                  width="85"
                >
                  <v-row no-gutters style="height: 100%;">
                    <v-col cols="12" align-self="center" align="center" class="pb-5">
                    <span style="display: block;transform: rotate(-90deg);position: absolute;" class="font-18 text-white">หญิงตั้งครรภ์</span>
                    </v-col>
                  </v-row>
                </v-sheet>

                <v-sheet
                  v-else
                  color="#00A99D"
                  height="50"
                >
                  <v-row no-gutters style="height: 100%;">
                    <v-col cols="12" align-self="center" align="center">
                    <span class="font-16 text-white">หญิงตั้งครรภ์</span>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-col>

              <v-col cols="12" xl="11" lg="11" md="10" sm="10" :class="display_vuetify == 'xs' ? 'px-3' : display_vuetify == 'lg' ? 'px-3':'px-0' ">
                <v-row :class="display_vuetify == 'xs' ? 'pl-2' : 'px-0'">
                  <v-col cols="12" xl="3" lg="4" md="4" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">เลขบัตรประชาชน</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.pregnant_woman.cardnum"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                        @input="splitDatID('id4')"
                        v-mask="[mask_id]"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกเลขบัตรประชาชน</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.pregnant_woman.cardnum || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="3" lg="4" md="4" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ชื่อ - นามสกุล</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.pregnant_woman.fullname"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอก ชื่อ - นามสกุล</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.pregnant_woman.fullname || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="2" lg="4" md="4" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">วันเดือนปีเกิด</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-menu
                        v-model="day_menu2"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="350px"
                        min-width="auto"
                        bottom
                        left
                        :disabled="status == 'see'"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            solo
                            dense
                            append-icon="mdi-calendar-multiselect"
                            :value="displayDate2()"
                            v-bind="attrs"
                            hide-details
                            v-on="on"
                            color="#00A99D"
                            item-color="teal darken-2"
                            :rules="status == 'see' ? [] : rules_input"
                            :readonly="status == 'see'"
                          >
                            <template slot="append">
                              <v-btn text icon width="10px" v-on="on" :readonly="status == 'see'">
                                <v-icon color="#00A99D"
                                  >mdi-calendar-multiselect</v-icon
                                >
                              </v-btn>
                            </template>

                            <template slot="label">
                              <span class="font-14">วัน/เดือน/ปี เกิด</span>
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          v-model="data.pregnant_woman.birth_date"
                          :max="dateNow"
                          no-title
                          scrollable
                          locale="th"
                          @input="day_menu2 = false"
                          color="#00A99D"
                          ref="picker"
                          :readonly="status == 'see'"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="#00A99D" @click="clearDaySelect2"
                            >ล้างค่า/clear</v-btn
                          >
                        </v-date-picker>
                      </v-menu>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ showDate(data.pregnant_woman.birth_date) || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="2" lg="2" md="4" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">กรุ๊ปเลือด</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-select
                        solo
                        v-model="data.pregnant_woman.blood"
                        :items="[
                          'A+',
                          'A-',
                          'B+',
                          'B-',
                          'O+',
                          'O-',
                          'AB+',
                          'AB-',
                        ]"
                        dense
                        color="#00A99D"
                        item-color="teal darken-2"
                        :menu-props="{ bottom: true, offsetY: true }"
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                      >
                        <template slot="append">
                          <v-btn text icon width="10px">
                            <v-icon color="#00A99D">mdi-chevron-down</v-icon>
                          </v-btn>
                        </template>
                        <template slot="label">
                          <span class="font-14">กรุณาเลือกกรุ๊ปเลือด</span>
                        </template>
                      </v-select>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.pregnant_woman.blood || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="1" lg="2" md="4" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">น้ำหนัก</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.pregnant_woman.weight"
                        :rules="status == 'see' ? [] : rules_input_num"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกน้ำหนัก</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.pregnant_woman.weight || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="1" lg="2" md="4" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ส่วนสูง</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.pregnant_woman.height"
                        :rules="status == 'see' ? [] : rules_input_num"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกส่วนสูง</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.pregnant_woman.height || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="2" lg="2" md="4" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">BP: ครั้งที่ 1</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.pregnant_woman.BP1"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกข้อมูล</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.pregnant_woman.BP1 || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="1" lg="2" md="4" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">P: </span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.pregnant_woman.P"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกข้อมูล</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">{{ data.pregnant_woman.P || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="2" lg="2" md="4" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">BP: ครั้งที่ 2</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.pregnant_woman.BP2"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกข้อมูล</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.pregnant_woman.BP2 || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="1" lg="2" md="4" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">DTX</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.pregnant_woman.DTX.detail"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกข้อมูล</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.pregnant_woman.DTX.detail || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="2" lg="2" md="4" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-checkbox
                        v-model="data.pregnant_woman.DTX.answer_title"
                        value="งด"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                        @click="data.pregnant_woman.DTX.status = '1'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">งด</span>
                        </template>
                      </v-checkbox>

                      <v-checkbox
                        v-model="data.pregnant_woman.DTX.answer_title"
                        value="ไม่งด"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                        @click="data.pregnant_woman.DTX.status = '2'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">ไม่งด</span>
                        </template>
                      </v-checkbox>
                    </v-row>

                    <v-row v-else no-gutters class="ma-0">
                      <span class="pt-2 font-16 text-000000">{{ data.pregnant_woman.DTX.answer_title || '' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="2" lg="4" md="4" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">โรคประจำตัว</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.pregnant_woman.personal_diseases"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกโรคประจำตัว</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.pregnant_woman.personal_diseases || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="2" lg="4" md="4" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">แพ้ยา</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.pregnant_woman.allergy_medicine"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกข้อมูลการแพ้ยา</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.pregnant_woman.allergy_medicine || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="3" lg="4" md="4" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ประวัติการตั้งครรภ์ ครรภ์ที่</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.pregnant_woman.history_pregnancy.pregnancy_times"
                        :rules="status == 'see' ? [] : rules_input_num"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกข้อมูล</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.pregnant_woman.history_pregnancy.pregnancy_times || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="2" lg="4" md="4" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">สถานที่คลอด</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.pregnant_woman.history_pregnancy.place_birth"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกสถานที่คลอด</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.pregnant_woman.history_pregnancy.place_birth || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="2" lg="4" md="4" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">วิธีคลอด</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.pregnant_woman.history_pregnancy.how_to_birth"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกวิธีคลอด</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.pregnant_woman.history_pregnancy.how_to_birth || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="1" lg="2" md="4" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">อายุครรภ์</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.pregnant_woman.history_pregnancy.age_pregnancy"
                        :rules="status == 'see' ? [] : rules_input_num"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกอายุครรภ์</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.pregnant_woman.history_pregnancy.age_pregnancy || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="1" lg="2" md="4" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">LPM</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.pregnant_woman.history_pregnancy.LPM"
                        :rules="status == 'see' ? [] : rules_input_num"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกข้อมูล</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.pregnant_woman.history_pregnancy.LPM || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="1" lg="2" md="4" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">EDC</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.pregnant_woman.history_pregnancy.EDC"
                        :rules="status == 'see' ? [] : rules_input_num"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกข้อมูล</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.pregnant_woman.history_pregnancy.EDC || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="2" lg="6" md="4" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">สถานที่ฝากครรภ์</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.pregnant_woman.history_pregnancy.place_prenatal_care"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกสถานที่ฝากครรภ์</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.pregnant_woman.history_pregnancy.place_prenatal_care || '-' }}</span>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-row>

          <v-row :class="display_vuetify == 'xs' ? 'mt-5 mb-8 pb-0 px-1':'my-5 px-5 pt-3 pb-1'" style="border: 5px solid #00A99D;">
            <v-row class="ma-0">
              <v-col cols="12" xl="1" lg="1" md="2" sm="2" :class="display_vuetify == 'xs' ? 'pr-3' : 'py-1 px-2'">
                <v-sheet
                  v-if="display_vuetify !== 'xs'"
                  color="#00A99D"
                  style="height: 100%;"
                  width="80"
                >
                  <v-row no-gutters style="height: 100%;">
                    <v-col cols="12" align-self="center" align="center">
                    <span style="display: block;transform: rotate(-90deg);" class="font-18 text-white">15 ปีขึ้นไป</span>
                    </v-col>
                  </v-row>
                </v-sheet>

                <v-sheet
                  v-else
                  color="#00A99D"
                  height="50"
                >
                  <v-row no-gutters style="height: 100%;">
                    <v-col cols="12" align-self="center" align="center">
                    <span class="font-16 text-white">15 ปีขึ้นไป</span>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-col>
              
              <v-col cols="12" xl="10" lg="10" md="8" sm="8" :class="display_vuetify == 'xs' ? 'px-3' : display_vuetify == 'lg' ? 'px-3':'px-0' ">
                <v-row :class="display_vuetify == 'xs' ? 'pl-2' : 'px-0'">
                  <v-col cols="12" xl="3" lg="4" md="6" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">เลขบัตรประชาชน</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.over15.cardnum"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                        @input="splitDatID('id5')"
                        v-mask="[mask_id]"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกเลขบัตรประชาชน</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.over15.cardnum || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="3" lg="4" md="6" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ชื่อ - นามสกุล</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.over15.fullname"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอก ชื่อ - นามสกุล</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.over15.fullname || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="2" lg="4" md="6" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">วันเดือนปีเกิด</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-menu
                        v-model="day_menu3"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="350px"
                        min-width="auto"
                        bottom
                        left
                        :disabled="status == 'see'"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            solo
                            dense
                            append-icon="mdi-calendar-multiselect"
                            :value="displayDate3()"
                            v-bind="attrs"
                            hide-details
                            v-on="on"
                            color="#00A99D"
                            item-color="teal darken-2"
                            :rules="status == 'see' ? [] : rules_input"
                            :readonly="status == 'see'"
                          >
                            <template slot="append">
                              <v-btn text icon width="10px" v-on="on" :readonly="status == 'see'">
                                <v-icon color="#00A99D"
                                  >mdi-calendar-multiselect</v-icon
                                >
                              </v-btn>
                            </template>

                            <template slot="label">
                              <span class="font-14">วัน/เดือน/ปี เกิด</span>
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          v-model="data.over15.birth_date"
                          :max="dateNow"
                          no-title
                          scrollable
                          locale="th"
                          @input="day_menu3 = false"
                          color="#00A99D"
                          ref="picker"
                          :readonly="status == 'see'"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="#00A99D" @click="clearDaySelect3"
                            >ล้างค่า/clear</v-btn
                          >
                        </v-date-picker>
                      </v-menu>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ showDate(data.over15.birth_date) || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="2" lg="2" md="6" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">กรุ๊ปเลือด</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-select
                        solo
                        v-model="data.over15.blood"
                        :items="[
                          'A+',
                          'A-',
                          'B+',
                          'B-',
                          'O+',
                          'O-',
                          'AB+',
                          'AB-',
                        ]"
                        dense
                        color="#00A99D"
                        item-color="teal darken-2"
                        :menu-props="{ bottom: true, offsetY: true }"
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                      >
                        <template slot="append">
                          <v-btn text icon width="10px">
                            <v-icon color="#00A99D">mdi-chevron-down</v-icon>
                          </v-btn>
                        </template>
                        <template slot="label">
                          <span class="font-14">กรุณาเลือกกรุ๊ปเลือด</span>
                        </template>
                      </v-select>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.over15.blood || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="2" lg="2" md="6" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">น้ำหนัก</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.over15.weight"
                        :rules="status == 'see' ? [] : rules_input_num"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกน้ำหนัก</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.over15.weight || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="1" lg="2" md="6" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ส่วนสูง</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.over15.height"
                        :rules="status == 'see' ? [] : rules_input_num"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกส่วนสูง</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.over15.height || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="1" lg="2" md="6" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">รอบเอว</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.over15.around_waist"
                        :rules="status == 'see' ? [] : rules_input_num"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกรอบเอว</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.over15.around_waist || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="2" lg="2" md="6" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">สะโพก</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.over15.around_hips"
                        :rules="status == 'see' ? [] : rules_input_num"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกสะโพก</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.over15.around_hips || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="2" lg="2" md="6" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">แพ้ยา</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.over15.allergy_medicine"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกข้อมูลการแพ้ยา</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.over15.allergy_medicine || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="2" lg="2" md="6" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">BP: ครั้งที่ 1</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.over15.BP1"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกข้อมูล</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.over15.BP1 || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="2" lg="2" md="6" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">P:</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.over15.P"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกข้อมูล</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.over15.P || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="2" lg="2" md="6" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">BP: ครั้งที่ 2</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.over15.BP2"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกข้อมูล</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.over15.BP2 || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="1" lg="2" md="6" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">DTX</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.over15.DTX.detail"
                        :rules="status == 'see' ? [] : rules_input"
                        :readonly="status == 'see'"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกข้อมูล</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.over15.DTX.detail || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="2" lg="2" md="4" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-checkbox
                        v-model="data.over15.DTX.answer_title"
                        value="งด"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                        @click="data.over15.DTX.status = '1'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">งด</span>
                        </template>
                      </v-checkbox>

                      <v-checkbox
                        v-model="data.over15.DTX.answer_title"
                        value="ไม่งด"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                        @click="data.over15.DTX.status = '2'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">ไม่งด</span>
                        </template>
                      </v-checkbox>
                    </v-row>

                    <v-row v-else no-gutters class="ma-0">
                      <span class="pt-2 font-16 text-000000">ระบุ : {{ data.over15.DTX.answer_title || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="4" lg="6" md="4" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ศาสนา</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-checkbox
                        v-model="data.over15.religion.detail"
                        value="พุทธ"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                        @click="data.over15.religion.status = '1'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">พุทธ</span>
                        </template>
                      </v-checkbox>

                      <v-checkbox
                        v-model="data.over15.religion.detail"
                        value="อิสลาม"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                        @click="data.over15.religion.status = '2'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">อิสลาม</span>
                        </template>
                      </v-checkbox>

                      <v-checkbox
                        v-model="data.over15.religion.detail"
                        value="คริสต์"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                        @click="data.over15.religion.status = '3'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">คริสต์</span>
                        </template>
                      </v-checkbox>

                      <v-checkbox
                        v-model="data.over15.religion.detail"
                        value="อื่นๆ"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                        @click="data.over15.religion.status = '4'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">อื่นๆ</span>
                        </template>
                      </v-checkbox>

                      <v-row v-if="data.over15.religion.detail == 'อื่นๆ'" no-gutters>
                        <v-text-field
                          dense
                          solo
                          hide-details="auto"
                          v-model="data.over15.religion.answer_title"
                          :rules="status == 'see' ? [] : rules_input"
                          :readonly="status == 'see'"
                        >
                          <template slot="label">
                            <span class="font-14">กรุณากรอกศาสนา</span>
                          </template>
                        </v-text-field>
                      </v-row>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.over15.religion.detail || '-' }}</span>
                      <span v-if="data.over15.religion.detail == 'อื่นๆ'" class="pt-2 mx-3 font-16 text-000000">ระบุ : {{ data.over15.religion.answer_title || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="5" lg="6" md="4" sm="6" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">สถานะ</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-checkbox
                        v-model="data.over15.person_status.answer_title"
                        value="โสด"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                        @click="data.over15.person_status.status = '1'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">โสด</span>
                        </template>
                      </v-checkbox>

                      <v-checkbox
                        v-model="data.over15.person_status.answer_title"
                        value="หม้าย"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                        @click="data.over15.person_status.status = '2'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">หม้าย</span>
                        </template>
                      </v-checkbox>
                    
                      <v-row no-gutters>
                        <v-checkbox
                          v-model="data.over15.person_status.answer_title"
                          value="คู่"
                          dense
                          hide-details="auto"
                          :rules="status == 'see' ? [] : rules_select"
                          :readonly="status == 'see'"
                          color="#00A99D"
                          class="mt-1 mr-5"
                          @click="data.over15.person_status.status = '3'"
                        >
                          <template slot="label">
                            <span class="font-16 text-000000">คู่</span>
                          </template>
                        </v-checkbox>

                        <v-row v-if="data.over15.person_status.answer_title == 'คู่'" no-gutters>
                          <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ชื่อ-สกุลคู่สมรส</span>
                          <v-text-field
                            v-model="data.over15.spouse_name"
                            dense
                            solo
                            hide-details="auto"
                            :rules="status == 'see' ? [] : rules_input"
                            :readonly="status == 'see'"
                          >
                            <template slot="label">
                              <span class="font-14">กรุณากรอกชื่อ-สกุลคู่สมรส</span>
                            </template>
                          </v-text-field>
                        </v-row>
                      </v-row>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.over15.person_status.answer_title || '-' }}</span>
                      <span v-if="data.over15.person_status.answer_title == 'คู่'" class="px-3 pt-2 font-16 text-000000">ชื่อ-สกุลคู่สมรส : {{ data.over15.spouse_name || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="8" lg="6" md="8" sm="8" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">การคุมกำเนิด</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-checkbox
                        v-model="data.over15.birth_control.answer_title"
                        value="ถุงยาง"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                        @click="data.over15.birth_control.status = '1'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">ถุงยาง</span>
                        </template>
                      </v-checkbox>

                      <v-checkbox
                        v-model="data.over15.birth_control.answer_title"
                        value="ยาเม็ด"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                        @click="data.over15.birth_control.status = '2'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">ยาเม็ด</span>
                        </template>
                      </v-checkbox>

                      <v-checkbox
                        v-model="data.over15.birth_control.answer_title"
                        value="แผ่นแปะ"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                        @click="data.over15.birth_control.status = '3'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">แผ่นแปะ</span>
                        </template>
                      </v-checkbox>

                      <v-checkbox
                        v-model="data.over15.birth_control.answer_title"
                        value="วงแหวน"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                        @click="data.over15.birth_control.status = '4'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">วงแหวน</span>
                        </template>
                      </v-checkbox>

                      <v-checkbox
                        v-model="data.over15.birth_control.answer_title"
                        value="ยาฉีด"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                        @click="data.over15.birth_control.status = '5'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">ยาฉีด</span>
                        </template>
                      </v-checkbox>

                      <v-checkbox
                        v-model="data.over15.birth_control.answer_title"
                        value="ห่วงอนามัย"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                        @click="data.over15.birth_control.status = '6'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">ห่วงอนามัย</span>
                        </template>
                      </v-checkbox>

                      <v-checkbox
                        v-model="data.over15.birth_control.answer_title"
                        value="ยาฝัง"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                        @click="data.over15.birth_control.status = '7'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">ยาฝัง</span>
                        </template>
                      </v-checkbox>

                      <v-checkbox
                        v-model="data.over15.birth_control.answer_title"
                        value="ทำหมัน"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                        @click="data.over15.birth_control.status = '8'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">ทำหมัน</span>
                        </template>
                      </v-checkbox>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.over15.birth_control.answer_title || '-' }}</span>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xl="4" lg="6" md="4" sm="4" class="d-flex d-flex-row pl-0 pb-0">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ประเภทการอยู่อาศัย</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-checkbox
                        v-model="data.over15.living.answer_title"
                        value="Type 1"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                        @click="data.over15.living.status = '1'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">Type 1</span>
                        </template>
                      </v-checkbox>

                      <v-checkbox
                        v-model="data.over15.living.answer_title"
                        value="Type 2"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                        @click="data.over15.living.status = '2'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">Type 2</span>
                        </template>
                      </v-checkbox>

                      <v-checkbox
                        v-model="data.over15.living.answer_title"
                        value="ย้ายออก"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                        @click="data.over15.living.status = '3'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">ย้ายออก</span>
                        </template>
                      </v-checkbox>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.over15.living.answer_title || '-' }}</span>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" xl="1" lg="1" md="2" sm="2" class="px-0" align="center">
                <v-img
                  src="@/assets/icon/visit/image.svg"
                  height="100px"
                  width="100px"
                />
              </v-col>
            </v-row>

            <v-row class="ma-0">
              <v-col v-if="display_vuetify !== 'xs'" xl="1" lg="1" md="2" sm="2"></v-col>
              <v-col cols="12" xl="11" lg="11" md="10" sm="10" :class="display_vuetify == 'xs' ? 'px-3' : 'px-0'">
                <v-row no-gutters class="ma-0">
                  <v-col cols="10" xl="4" lg="5" md="12" sm="12" class="d-flex d-flex-row pl-0 pb-3">
                    <span class="mr-5 pt-2 font-16 text-000000" style="white-space: nowrap;">1. มะเร็งเต้านม (30 – 70 ปี)</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-checkbox
                        v-model="data.over15.breast_cancer.status"
                        value="false"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">ไม่ได้ตรวจ</span>
                        </template>
                      </v-checkbox>

                      <v-checkbox
                        v-model="data.over15.breast_cancer.status"
                        value="true"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">ตรวจแล้ว</span>
                        </template>
                      </v-checkbox>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span v-if="data.over15.breast_cancer.status == 'true'" class="pt-2 font-16 text-000000">: ตรวจแล้ว</span>
                      <span v-else-if="data.over15.breast_cancer.status == 'false'" class="pt-2 font-16 text-000000">: ไม่ได้ตรวจ</span>
                      <span v-else class="pt-2 font-16 text-000000">: -</span>
                    </v-row>
                  </v-col>

                  <v-col v-if="data.over15.breast_cancer.status == 'true'" cols="10" xl="8" lg="7" md="12" sm="12" class="d-flex d-flex-row pl-0 pb-0">
                    <v-row no-gutters>
                      <v-col cols="12" xl="4" lg="4" md="4" sm="4" class="d-flex d-flex-row pb-3">
                        <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">วันที่ตรวจ</span>
                        <v-row v-if="status !== 'detail'" no-gutters>
                          <v-menu
                            v-model="day_menu4"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="350px"
                            min-width="auto"
                            bottom
                            left
                            :disabled="status == 'see'"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                solo
                                dense
                                append-icon="mdi-calendar-multiselect"
                                :value="displayDate4()"
                                v-bind="attrs"
                                hide-details
                                v-on="on"
                                color="#00A99D"
                                item-color="teal darken-2"
                                class="mr-2"
                                :rules="status == 'see' ? [] : rules_input"
                                :readonly="status == 'see'"
                              >
                                <template slot="append">
                                  <v-btn text icon width="10px" v-on="on" :readonly="status == 'see'">
                                    <v-icon color="#00A99D"
                                      >mdi-calendar-multiselect</v-icon
                                    >
                                  </v-btn>
                                </template>

                                <template slot="label">
                                  <span class="font-14">วัน/เดือน/ปี ที่ตรวจ</span>
                                </template>
                              </v-text-field>
                            </template>
                            <v-date-picker
                              v-model="data.over15.breast_cancer.inspection_date"
                              :max="dateNow"
                              no-title
                              scrollable
                              locale="th"
                              @input="day_menu4 = false"
                              color="#00A99D"
                              ref="picker"
                              :readonly="status == 'see'"
                            >
                              <v-spacer></v-spacer>
                              <v-btn text color="#00A99D" @click="clearDaySelect4"
                                >ล้างค่า/clear</v-btn
                              >
                            </v-date-picker>
                          </v-menu>
                        </v-row>

                        <v-row v-else no-gutters>
                          <span class="pt-2 font-16 text-000000">: {{ showDate(data.over15.breast_cancer.inspection_date) || '-' }}</span>
                        </v-row>
                      </v-col>
                      <v-col cols="12" xl="4" lg="4" md="4" sm="4" class="d-flex d-flex-row pb-3">
                        <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">สถานที่ตรวจ</span>
                        <v-row v-if="status !== 'detail'" no-gutters>
                          <v-text-field
                            dense
                            solo
                            hide-details="auto"
                            v-model="data.over15.breast_cancer.inspection_location"
                            :rules="status == 'see' ? [] : rules_input"
                            :readonly="status == 'see'"
                            class="mr-2"
                          >
                            <template slot="label">
                              <span class="font-14">กรุณากรอกสถานที่ตรวจ</span>
                            </template>
                          </v-text-field>
                        </v-row>

                        <v-row v-else no-gutters>
                          <span class="pt-2 font-16 text-000000">: {{ data.over15.breast_cancer.inspection_location || '-' }}</span>
                        </v-row>
                      </v-col>
                      <v-col cols="12" xl="4" lg="4" md="4" sm="4" class="d-flex d-flex-row pb-3">
                        <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ผลตรวจล่าสุด</span>
                        <v-row v-if="status !== 'detail'" no-gutters>
                          <v-text-field
                            dense
                            solo
                            hide-details="auto"
                            v-model="data.over15.breast_cancer.last_inspection_result"
                            :rules="status == 'see' ? [] : rules_input"
                            :readonly="status == 'see'"
                            class="mr-2"
                          >
                            <template slot="label">
                              <span class="font-14">กรุณากรอกผลตรวจล่าสุด</span>
                            </template>
                          </v-text-field>
                        </v-row>

                        <v-row v-else no-gutters>
                          <span class="pt-2 font-16 text-000000">: {{ data.over15.breast_cancer.last_inspection_result || '-' }}</span>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row no-gutters class="ma-0">
                  <v-col cols="10" xl="4" lg="5" md="12" sm="12" class="d-flex d-flex-row pl-0 pb-3">
                    <span class="mr-10 pt-2 font-16 text-000000" style="white-space: nowrap;">2. มะเร็งลำไส้ (50-70 ปี)</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-checkbox
                        v-model="data.over15.colon_cancer.status"
                        value="false"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">ไม่ได้ตรวจ</span>
                        </template>
                      </v-checkbox>

                      <v-checkbox
                        v-model="data.over15.colon_cancer.status"
                        value="true"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">ตรวจแล้ว</span>
                        </template>
                      </v-checkbox>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span v-if="data.over15.colon_cancer.status == 'true'" class="pt-2 font-16 text-000000">: ตรวจแล้ว</span>
                      <span v-else-if="data.over15.colon_cancer.status == 'false'" class="pt-2 font-16 text-000000">: ไม่ได้ตรวจ</span>
                      <span v-else class="pt-2 font-16 text-000000">: -</span>
                    </v-row>
                  </v-col>

                  <v-col v-if="data.over15.colon_cancer.status == 'true'" cols="10" xl="8" lg="7" md="12" sm="12" class="d-flex d-flex-row pl-0 py-0">
                    <v-row no-gutters>
                      <v-col cols="12" xl="4" lg="4" md="4" sm="4" class="d-flex d-flex-row pb-3">
                        <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">วันที่ตรวจ</span>
                        <v-row v-if="status !== 'detail'" no-gutters>
                          <v-menu
                            v-model="day_menu5"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="350px"
                            min-width="auto"
                            bottom
                            left
                            :disabled="status == 'see'"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                solo
                                dense
                                append-icon="mdi-calendar-multiselect"
                                :value="displayDate5()"
                                v-bind="attrs"
                                hide-details
                                v-on="on"
                                color="#00A99D"
                                item-color="teal darken-2"
                                class="mr-2"
                                :rules="status == 'see' ? [] : rules_input"
                                :readonly="status == 'see'"
                              >
                                <template slot="append">
                                  <v-btn text icon width="10px" v-on="on" :readonly="status == 'see'">
                                    <v-icon color="#00A99D"
                                      >mdi-calendar-multiselect</v-icon
                                    >
                                  </v-btn>
                                </template>

                                <template slot="label">
                                  <span class="font-14">วัน/เดือน/ปี ที่ตรวจ</span>
                                </template>
                              </v-text-field>
                            </template>
                            <v-date-picker
                              v-model="data.over15.colon_cancer.inspection_date"
                              :max="dateNow"
                              no-title
                              scrollable
                              locale="th"
                              @input="day_menu5 = false"
                              color="#00A99D"
                              ref="picker"
                              :readonly="status == 'see'"
                            >
                              <v-spacer></v-spacer>
                              <v-btn text color="#00A99D" @click="clearDaySelect5"
                                >ล้างค่า/clear</v-btn
                              >
                            </v-date-picker>
                          </v-menu>
                        </v-row>

                        <v-row v-else no-gutters>
                          <span class="pt-2 font-16 text-000000">: {{ showDate(data.over15.colon_cancer.inspection_date) || '-' }}</span>
                        </v-row>
                      </v-col>
                      <v-col cols="12" xl="4" lg="4" md="4" sm="4" class="d-flex d-flex-row pb-3">
                        <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">สถานที่ตรวจ</span>
                        <v-row v-if="status !== 'detail'" no-gutters>
                          <v-text-field
                            dense
                            solo
                            hide-details="auto"
                            v-model="data.over15.colon_cancer.inspection_location"
                            :rules="status == 'see' ? [] : rules_input"
                            :readonly="status == 'see'"
                            class="mr-2"
                          >
                            <template slot="label">
                              <span class="font-14">กรุณากรอกสถานที่ตรวจ</span>
                            </template>
                          </v-text-field>
                        </v-row>

                        <v-row v-else no-gutters>
                          <span class="pt-2 font-16 text-000000">: {{ data.over15.colon_cancer.inspection_location || '-' }}</span>
                        </v-row>
                      </v-col>
                      <v-col cols="12" xl="4" lg="4" md="4" sm="4" class="d-flex d-flex-row pb-3">
                        <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ผลตรวจล่าสุด</span>
                        <v-row v-if="status !== 'detail'" no-gutters>
                          <v-text-field
                            dense
                            solo
                            hide-details="auto"
                            v-model="data.over15.colon_cancer.last_inspection_result"
                            :rules="status == 'see' ? [] : rules_input"
                            :readonly="status == 'see'"
                            class="mr-2"
                          >
                            <template slot="label">
                              <span class="font-14">กรุณากรอกผลตรวจล่าสุด</span>
                            </template>
                          </v-text-field>
                        </v-row>

                        <v-row v-else no-gutters>
                          <span class="pt-2 font-16 text-000000">: {{ data.over15.colon_cancer.last_inspection_result || '-' }}</span>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row no-gutters class="ma-0">
                  <v-col cols="10" xl="4" lg="5" md="12" sm="12" class="d-flex d-flex-row pl-0 pb-3">
                    <span class="mr-1 pt-2 font-16 text-000000" style="white-space: nowrap;">3. มะเร็งปากมดลูก(30 - 60 ปี)</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-checkbox
                        v-model="data.over15.cervical_cancer.status"
                        value="false"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">ไม่ได้ตรวจ</span>
                        </template>
                      </v-checkbox>

                      <v-checkbox
                        v-model="data.over15.cervical_cancer.status"
                        value="true"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">ตรวจแล้ว</span>
                        </template>
                      </v-checkbox>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span v-if="data.over15.cervical_cancer.status == 'true'" class="pt-2 font-16 text-000000">: ตรวจแล้ว</span>
                      <span v-else-if="data.over15.cervical_cancer.status == 'false'" class="pt-2 font-16 text-000000">: ไม่ได้ตรวจ</span>
                      <span v-else class="pt-2 font-16 text-000000">: -</span>
                    </v-row>
                  </v-col>

                  <v-col v-if="data.over15.cervical_cancer.status == 'true'" cols="10" xl="8" lg="7" md="12" sm="12" class="d-flex d-flex-row pl-0 py-0">
                    <v-row no-gutters>
                      <v-col cols="12" xl="4" lg="4" md="4" sm="4" class="d-flex d-flex-row pb-3">
                        <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">วันที่ตรวจ</span>
                        <v-row v-if="status !== 'detail'" no-gutters>
                          <v-menu
                            v-model="day_menu6"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="350px"
                            min-width="auto"
                            bottom
                            left
                            :disabled="status == 'see'"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                solo
                                dense
                                append-icon="mdi-calendar-multiselect"
                                :value="displayDate6()"
                                v-bind="attrs"
                                hide-details
                                v-on="on"
                                color="#00A99D"
                                item-color="teal darken-2"
                                class="mr-2"
                                :rules="status == 'see' ? [] : rules_input"
                                :readonly="status == 'see'"
                              >
                                <template slot="append">
                                  <v-btn text icon width="10px" v-on="on" :readonly="status == 'see'">
                                    <v-icon color="#00A99D"
                                      >mdi-calendar-multiselect</v-icon
                                    >
                                  </v-btn>
                                </template>

                                <template slot="label">
                                  <span class="font-14">วัน/เดือน/ปี ที่ตรวจ</span>
                                </template>
                              </v-text-field>
                            </template>
                            <v-date-picker
                              v-model="data.over15.cervical_cancer.inspection_date"
                              :max="dateNow"
                              no-title
                              scrollable
                              locale="th"
                              @input="day_menu6 = false"
                              color="#00A99D"
                              ref="picker"
                              :readonly="status == 'see'"
                            >
                              <v-spacer></v-spacer>
                              <v-btn text color="#00A99D" @click="clearDaySelect6"
                                >ล้างค่า/clear</v-btn
                              >
                            </v-date-picker>
                          </v-menu>
                        </v-row>

                        <v-row v-else no-gutters>
                          <span class="pt-2 font-16 text-000000">: {{ showDate(data.over15.cervical_cancer.inspection_date) || '-' }}</span>
                        </v-row>
                      </v-col>
                      <v-col cols="12" xl="4" lg="4" md="4" sm="4" class="d-flex d-flex-row pb-3">
                        <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">สถานที่ตรวจ</span>
                        <v-row v-if="status !== 'detail'" no-gutters>
                          <v-text-field
                            dense
                            solo
                            hide-details="auto"
                            v-model="data.over15.cervical_cancer.inspection_location"
                            :rules="status == 'see' ? [] : rules_input"
                            :readonly="status == 'see'"
                            class="mr-2"
                          >
                            <template slot="label">
                              <span class="font-14">กรุณากรอกสถานที่ตรวจ</span>
                            </template>
                          </v-text-field>
                        </v-row>

                        <v-row v-else no-gutters>
                          <span class="pt-2 font-16 text-000000">: {{ data.over15.cervical_cancer.inspection_location || '-' }}</span>
                        </v-row>
                      </v-col>
                      <v-col cols="12" xl="4" lg="4" md="4" sm="4" class="d-flex d-flex-row pb-3">
                        <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ผลตรวจล่าสุด</span>
                        <v-row v-if="status !== 'detail'" no-gutters>
                          <v-text-field
                            dense
                            solo
                            hide-details="auto"
                            v-model="data.over15.cervical_cancer.last_inspection_result"
                            :rules="status == 'see' ? [] : rules_input"
                            :readonly="status == 'see'"
                            class="mr-2"
                          >
                            <template slot="label">
                              <span class="font-14">กรุณากรอกผลตรวจล่าสุด</span>
                            </template>
                          </v-text-field>
                        </v-row>

                        <v-row v-else no-gutters>
                          <span class="pt-2 font-16 text-000000">: {{ data.over15.cervical_cancer.last_inspection_result || '-' }}</span>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row no-gutters class="ma-0">
                  <v-col cols="11" xl="2" lg="3" sm="6" md="6" class="d-flex d-flex-row pa-0 pb-3">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">G-P-A last</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-text-field
                        dense
                        solo
                        hide-details="auto"
                        v-model="data.over15.GPA_last"
                        :rules="status == 'see' ? [] : rules_input_num"
                        :readonly="status == 'see'"
                        class="mr-2"
                      >
                        <template slot="label">
                          <span class="font-14">กรุณากรอกข้อมูล</span>
                        </template>
                      </v-text-field>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000">: {{ data.over15.GPA_last || '-' }}</span>
                    </v-row>

                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ปี LMP</span>
                  </v-col>
                </v-row>

                <v-row no-gutters class="ma-0">
                  <v-col cols="12" class="d-flex d-flex-row pa-0 pb-3">
                    <v-row no-gutters>
                      <span class="mr-2 pt-2 font-16 text-000000 w-600"><u>ข้อมูลเกี่ยวกับอารมณ์โดยการคัดกรองโรคซึมเศร้า</u></span>
                      <span class="mx-3 pt-2 font-16 text-000000" style="white-space: nowrap;">2Q</span>
                      <v-row v-if="status !== 'detail'" no-gutters>
                        <v-checkbox
                          v-model="data.over15.information_depression.answer_title"
                          value="ปกติ (ไม่มีทั้ง 2 ข้อ) 1B0280"
                          dense
                          hide-details="auto"
                          :rules="status == 'see' ? [] : rules_select"
                          :readonly="status == 'see'"
                          color="#00A99D"
                          class="mt-1 mr-5"
                          @click="data.over15.information_depression.status = '1', 
                          data.over15.information_depression.subanswer_title_1.status = '', 
                          data.over15.information_depression.subanswer_title_2.status = '',
                          data.over15.information_depression.subanswer_title_1.answer_title = '',
                          data.over15.information_depression.subanswer_title_2.answer_title = ''"
                        >
                          <template slot="label">
                            <span class="font-16 text-000000">ปกติ (ไม่มีทั้ง 2 ข้อ) 1B0280</span>
                          </template>
                        </v-checkbox>

                        <v-checkbox
                          v-model="data.over15.information_depression.answer_title"
                          value="มีความเสี่ยง (มีข้อใดข้อหนึ่ง) ทำ 9Q 1B0281 (ทดสอบผ่านเว็บไซต์)"
                          dense
                          hide-details="auto"
                          :rules="status == 'see' ? [] : rules_select"
                          :readonly="status == 'see'"
                          color="#00A99D"
                          class="mt-1 mr-5"
                          @click="data.over15.information_depression.status = '2'"
                        >
                          <template slot="label">
                            <span class="font-16 text-000000">มีความเสี่ยง (มีข้อใดข้อหนึ่ง) ทำ 9Q 1B0281 (ทดสอบผ่านเว็บไซต์)</span>
                          </template>
                        </v-checkbox>
                      </v-row>

                      <v-row v-else no-gutters>
                        <span class="pt-2 font-16 text-000000">: {{ data.over15.information_depression.answer_title || '-' }}</span>
                      </v-row>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row no-gutters class="ma-0">
                  <v-col cols="12" class="d-flex d-flex-row pa-0 pb-3">
                    <v-row no-gutters>
                      <span class="mr-2 pt-2 font-16 text-000000">1. ใน 2 สัปดาห์ รู้สึกหดหู่ เศร้า หรือท้อแท้ สิ้นหวังหรือไม่</span>
                      <v-row v-if="status !== 'detail'" no-gutters :class="display_vuetify == 'xs' ? '' : 'pl-5'">
                        <v-checkbox
                          v-model="data.over15.information_depression.subanswer_title_1.status"
                          value="true"
                          dense
                          hide-details="auto"
                          :rules="status == 'see' ? [] : rules_select"
                          :readonly="status == 'see' || data.over15.information_depression.answer_title == 'ปกติ (ไม่มีทั้ง 2 ข้อ) 1B0280'"
                          color="#00A99D"
                          class="mt-1 mr-5"
                          @click="data.over15.information_depression.subanswer_title_1.answer_title = 'ใน 2 สัปดาห์ รู้สึกหดหู่ เศร้า หรือท้อแท้ สิ้นหวังหรือไม่'"
                        >
                          <template slot="label">
                            <span class="font-16 text-000000">มี</span>
                          </template>
                        </v-checkbox>

                        <v-checkbox
                          v-model="data.over15.information_depression.subanswer_title_1.status"
                          value="false"
                          dense
                          hide-details="auto"
                          :rules="status == 'see' ? [] : rules_select"
                          :readonly="status == 'see' || data.over15.information_depression.answer_title == 'ปกติ (ไม่มีทั้ง 2 ข้อ) 1B0280'"
                          color="#00A99D"
                          class="mt-1 mr-5"
                          @click="data.over15.information_depression.subanswer_title_1.answer_title = 'ใน 2 สัปดาห์ รู้สึกหดหู่ เศร้า หรือท้อแท้ สิ้นหวังหรือไม่'"
                        >
                          <template slot="label">
                            <span class="font-16 text-000000">ไม่มี</span>
                          </template>
                        </v-checkbox>
                      </v-row>

                      <v-row v-else no-gutters>
                        <span v-if="data.over15.information_depression.subanswer_title_1.status == 'true'" class="pt-2 font-16 text-000000">: มี</span>
                        <span v-else-if="data.over15.information_depression.subanswer_title_1.status == 'false'" class="pt-2 font-16 text-000000">: ไม่มี</span>
                        <span v-else class="pt-2 font-16 text-000000">: -</span>
                      </v-row>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row no-gutters class="ma-0">
                  <v-col cols="12" class="d-flex d-flex-row pa-0 pb-3">
                    <v-row no-gutters>
                      <span class="mr-2 pt-2 font-16 text-000000">2. ใน 2 สัปดาห์ รู้สึกเบื่อ ทำอะไรก็ไม่เพลินหรือไม่</span>
                      <v-row v-if="status !== 'detail'" no-gutters :class="display_vuetify == 'xs' ? '' : 'pl-16'">
                        <v-checkbox
                          v-model="data.over15.information_depression.subanswer_title_2.status"
                          value="true"
                          dense
                          hide-details="auto"
                          :rules="status == 'see' ? [] : rules_select"
                          :readonly="status == 'see' || data.over15.information_depression.answer_title == 'ปกติ (ไม่มีทั้ง 2 ข้อ) 1B0280'"
                          color="#00A99D"
                          class="mt-1 mr-5"
                          @click="data.over15.information_depression.subanswer_title_2.answer_title = 'ใน 2 สัปดาห์ รู้สึกเบื่อ ทำอะไรก็ไม่เพลินหรือไม่'"
                        >
                          <template slot="label">
                            <span class="font-16 text-000000">มี</span>
                          </template>
                        </v-checkbox>

                        <v-checkbox
                          v-model="data.over15.information_depression.subanswer_title_2.status"
                          value="false"
                          dense
                          hide-details="auto"
                          :rules="status == 'see' ? [] : rules_select"
                          :readonly="status == 'see' || data.over15.information_depression.answer_title == 'ปกติ (ไม่มีทั้ง 2 ข้อ) 1B0280'"
                          color="#00A99D"
                          class="mt-1 mr-5"
                          @click="data.over15.information_depression.subanswer_title_2.answer_title = 'ใน 2 สัปดาห์ รู้สึกเบื่อ ทำอะไรก็ไม่เพลินหรือไม่'"
                        >
                          <template slot="label">
                            <span class="font-16 text-000000">ไม่มี</span>
                          </template>
                        </v-checkbox>
                      </v-row>

                      <v-row v-else no-gutters>
                        <span v-if="data.over15.information_depression.subanswer_title_2.status == 'true'" class="pt-2 font-16 text-000000">: มี</span>
                        <span v-else-if="data.over15.information_depression.subanswer_title_2.status == 'false'" class="pt-2 font-16 text-000000">: ไม่มี</span>
                        <span v-else class="pt-2 font-16 text-000000">: -</span>
                      </v-row>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row no-gutters class="ma-0">
                  <v-col cols="12" :class="display_vuetify == 'xs' ? 'd-flex d-flex-row pr-3 pb-3' : 'd-flex d-flex-row pa-0 pb-3'">
                    <v-row no-gutters>
                      <v-col cols="12" xl="4" lg="4" class="pt-3">
                        <v-card class="pa-3 mr-2" style="background: linear-gradient(180deg, rgba(0, 169, 157, 0.25) 0%, rgba(0, 169, 157, 0) 100%);">
                          <v-row no-gutters>
                            <v-col cols="12">
                              <span class="mr-2 pt-2 font-16 text-000000 w-600">คัดกรองบุหรี่:</span>
                              <span class="mr-2 pt-2 font-16 text-000000">ประวัติ(ถ้าสูบให้ดำเนินการสอบถามต่อ)</span>
                            </v-col>
                            <v-col cols="12">
                              <v-row v-if="status !== 'detail'" no-gutters>
                                <v-checkbox
                                  v-model="data.over15.cigarette_screening.history.answer_title"
                                  value="ไม่สูบ"
                                  dense
                                  hide-details="auto"
                                  :rules="status == 'see' ? [] : rules_select"
                                  :readonly="status == 'see'"
                                  color="#00A99D"
                                  class="mt-1 mr-5"
                                  @click="data.over15.cigarette_screening.history.status = '1'"
                                >
                                  <template slot="label">
                                    <span class="font-16 text-000000">ไม่สูบ</span>
                                  </template>
                                </v-checkbox>

                                <v-checkbox
                                  v-model="data.over15.cigarette_screening.history.answer_title"
                                  value="เคยสูบ"
                                  dense
                                  hide-details="auto"
                                  :rules="status == 'see' ? [] : rules_select"
                                  :readonly="status == 'see'"
                                  color="#00A99D"
                                  class="mt-1 mr-5"
                                  @click="data.over15.cigarette_screening.history.status = '2'"
                                >
                                  <template slot="label">
                                    <span class="font-16 text-000000">เคยสูบ</span>
                                  </template>
                                </v-checkbox>
                              
                              <v-row no-gutters class="ma-0 pt-0">
                                <v-checkbox
                                  v-model="data.over15.cigarette_screening.history.answer_title"
                                  value="สูบ"
                                  dense
                                  hide-details="auto"
                                  :rules="status == 'see' ? [] : rules_select"
                                  :readonly="status == 'see'"
                                  color="#00A99D"
                                  class="mt-1 mr-5"
                                  @click="data.over15.cigarette_screening.history.status = '3'"
                                >
                                  <template slot="label">
                                    <span class="font-16 text-000000">สูบ</span>
                                  </template>
                                </v-checkbox>

                                  <v-row v-if="data.over15.cigarette_screening.history.answer_title == 'สูบ'" no-gutters>
                                    <span class="mr-2 pt-2 font-16 text-000000">ระบุชนิด</span>
                                    <v-text-field
                                      dense
                                      solo
                                      hide-details="auto"
                                      v-model="data.over15.cigarette_screening.history.more_answer_title"
                                      :rules="status == 'see' ? [] : rules_input"
                                      :readonly="status == 'see'"
                                      class="mr-2"
                                    >
                                      <template slot="label">
                                        <span class="font-14">กรุณากรอกข้อมูล</span>
                                      </template>
                                    </v-text-field>
                                  </v-row>
                                </v-row>
                              </v-row>

                              <v-row v-else no-gutters>
                                <span v-if="data.over15.cigarette_screening.history.answer_title !== 'สูบ'" class="pt-2 font-16 text-000000">{{ data.over15.cigarette_screening.history.answer_title || '-'}}</span>
                                <span v-else class="pt-2 font-16 text-000000">{{ data.over15.cigarette_screening.history.answer_title || '-'}} <span class="mr-3 pt-2 font-16 text-000000">ระบุชนิด : {{ data.over15.cigarette_screening.history.more_answer_title || '-'}}</span></span>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-col>
                      <v-col cols="12" xl="4" lg="4" class="pt-3">
                        <v-card class="pa-3 mr-2" style="background: linear-gradient(180deg, rgba(0, 169, 157, 0.25) 0%, rgba(0, 169, 157, 0) 100%);">
                          <v-row no-gutters>
                            <v-col cols="12">
                              <span class="mr-2 pt-2 font-16 text-000000 w-600">สูบหลังตื่นนอน</span>
                            </v-col>
                            <v-col cols="12">
                              <v-row v-if="status !== 'detail'" no-gutters>
                                <v-checkbox
                                  v-model="data.over15.cigarette_screening.smoke_after_wakeup.answer_title"
                                  value="น้อยกว่า 30 นาที"
                                  dense
                                  hide-details="auto"
                                  :rules="status == 'see' ? [] : rules_select"
                                  :readonly="status == 'see'"
                                  color="#00A99D"
                                  class="mt-1 mr-5"
                                  @click="data.over15.cigarette_screening.smoke_after_wakeup.status = '1'"
                                >
                                  <template slot="label">
                                    <span class="font-16 text-000000">น้อยกว่า 30 นาที</span>
                                  </template>
                                </v-checkbox>

                                <v-checkbox
                                  v-model="data.over15.cigarette_screening.smoke_after_wakeup.answer_title"
                                  value="มากกว่า 30 นาที"
                                  dense
                                  hide-details="auto"
                                  :rules="status == 'see' ? [] : rules_select"
                                  :readonly="status == 'see'"
                                  color="#00A99D"
                                  class="mt-1 mr-5"
                                  @click="data.over15.cigarette_screening.smoke_after_wakeup.status = '2'"
                                >
                                  <template slot="label">
                                    <span class="font-16 text-000000">มากกว่า 30 นาที</span>
                                  </template>
                                </v-checkbox>

                                <v-checkbox
                                  v-model="data.over15.cigarette_screening.smoke_after_wakeup.answer_title"
                                  value="1 ชั่วโมงหรือมากกว่า"
                                  dense
                                  hide-details="auto"
                                  :rules="status == 'see' ? [] : rules_select"
                                  :readonly="status == 'see'"
                                  color="#00A99D"
                                  class="mt-1 mr-5"
                                  @click="data.over15.cigarette_screening.smoke_after_wakeup.status = '3'"
                                >
                                  <template slot="label">
                                    <span class="font-16 text-000000">1 ชั่วโมงหรือมากกว่า</span>
                                  </template>
                                </v-checkbox>
                              </v-row>

                              <v-row v-else no-gutters>
                                <span class="pt-2 font-16 text-000000">{{ data.over15.cigarette_screening.smoke_after_wakeup.answer_title || '-' }}</span>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-col>
                      <v-col cols="12" xl="4" lg="4" class="pt-3">
                        <v-card class="pa-3 mr-2" style="background: linear-gradient(180deg, rgba(0, 169, 157, 0.25) 0%, rgba(0, 169, 157, 0) 100%);">
                          <v-row no-gutters>
                            <v-col cols="12">
                              <span class="mr-2 pt-2 font-16 text-000000 w-600">การติดตาม</span>
                            </v-col>
                            <v-col cols="12">
                              <v-row v-if="status !== 'detail'" no-gutters>
                                <v-checkbox
                                  v-model="data.over15.cigarette_screening.tracking.answer_title"
                                  value="1 เดือน"
                                  dense
                                  hide-details="auto"
                                  :rules="status == 'see' ? [] : rules_select"
                                  :readonly="status == 'see'"
                                  color="#00A99D"
                                  class="mt-1 mr-5"
                                  @click="data.over15.cigarette_screening.tracking.status = '1'"
                                >
                                  <template slot="label">
                                    <span class="font-16 text-000000">1 เดือน</span>
                                  </template>
                                </v-checkbox>

                                <v-checkbox
                                  v-model="data.over15.cigarette_screening.tracking.answer_title"
                                  value="3 เดือน"
                                  dense
                                  hide-details="auto"
                                  :rules="status == 'see' ? [] : rules_select"
                                  :readonly="status == 'see'"
                                  color="#00A99D"
                                  class="mt-1 mr-5"
                                  @click="data.over15.cigarette_screening.tracking.status = '2'"
                                >
                                  <template slot="label">
                                    <span class="font-16 text-000000">3 เดือน</span>
                                  </template>
                                </v-checkbox>

                                <v-checkbox
                                  v-model="data.over15.cigarette_screening.tracking.answer_title"
                                  value="6 เดือน"
                                  dense
                                  hide-details="auto"
                                  :rules="status == 'see' ? [] : rules_select"
                                  :readonly="status == 'see'"
                                  color="#00A99D"
                                  class="mt-1 mr-5"
                                  @click="data.over15.cigarette_screening.tracking.status = '3'"
                                >
                                  <template slot="label">
                                    <span class="font-16 text-000000">6 เดือน</span>
                                  </template>
                                </v-checkbox>
                              </v-row>

                              <v-row v-else no-gutters>
                                <span class="pt-2 font-16 text-000000">{{ data.over15.cigarette_screening.tracking.answer_title || '-' }}</span>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row no-gutters class="ma-0">
                  <v-col cols="12" :class="display_vuetify == 'xs' ? 'd-flex d-flex-row pr-3 pb-3' : 'd-flex d-flex-row pa-0 pb-3'">
                    <v-row no-gutters>
                      <v-col cols="12" xl="6" lg="6" class="pb-3">
                        <v-card class="pa-3 mr-2" style="background: linear-gradient(180deg, rgba(0, 169, 157, 0.25) 0%, rgba(0, 169, 157, 0) 100%);">
                          <v-row no-gutters>
                            <v-col cols="12">
                              <span class="mr-2 pt-2 font-16 text-000000 w-600">ปริมาณการสูบ</span>
                            </v-col>
                            <v-col cols="12">
                              <v-row v-if="status !== 'detail'" no-gutters>
                                <v-checkbox
                                  v-model="data.over15.cigarette_screening.amount_smoking.answer_title"
                                  value="1-10 มวน/วัน"
                                  dense
                                  hide-details="auto"
                                  :rules="status == 'see' ? [] : rules_select"
                                  :readonly="status == 'see'"
                                  color="#00A99D"
                                  class="mt-1 mr-5"
                                  @click="data.over15.cigarette_screening.amount_smoking.status = '1'"
                                >
                                  <template slot="label">
                                    <span class="font-16 text-000000">1-10 มวน/วัน</span>
                                  </template>
                                </v-checkbox>

                                <v-checkbox
                                  v-model="data.over15.cigarette_screening.amount_smoking.answer_title"
                                  value="11-19 มวน/วัน"
                                  dense
                                  hide-details="auto"
                                  :rules="status == 'see' ? [] : rules_select"
                                  :readonly="status == 'see'"
                                  color="#00A99D"
                                  class="mt-1 mr-5"
                                  @click="data.over15.cigarette_screening.amount_smoking.status = '2'"
                                >
                                  <template slot="label">
                                    <span class="font-16 text-000000">11-19 มวน/วัน</span>
                                  </template>
                                </v-checkbox>

                                <v-checkbox
                                  v-model="data.over15.cigarette_screening.amount_smoking.answer_title"
                                  value="20 มวนขึ้นไป/วัน"
                                  dense
                                  hide-details="auto"
                                  :rules="status == 'see' ? [] : rules_select"
                                  :readonly="status == 'see'"
                                  color="#00A99D"
                                  class="mt-1 mr-5"
                                  @click="data.over15.cigarette_screening.amount_smoking.status = '3'"
                                >
                                  <template slot="label">
                                    <span class="font-16 text-000000">20 มวนขึ้นไป/วัน</span>
                                  </template>
                                </v-checkbox>
                              </v-row>

                              <v-row v-else no-gutters>
                                <span class="pt-2 font-16 text-000000">{{ data.over15.cigarette_screening.amount_smoking.answer_title || '-' }}</span>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-col>
                      <v-col cols="12" xl="6" lg="6" class="pa-0">
                        <v-card class="pa-3 mr-2" style="background: linear-gradient(180deg, rgba(0, 169, 157, 0.25) 0%, rgba(0, 169, 157, 0) 100%);">
                          <v-row no-gutters>
                            <v-col cols="12">
                              <span class="mr-2 pt-2 font-16 text-000000 w-600">การสมัครเข้าร่วมโครงการ</span>
                            </v-col>
                            <v-col cols="12">
                              <v-row v-if="status !== 'detail'" no-gutters>
                                <v-checkbox
                                  v-model="data.over15.program_regis"
                                  value="true"
                                  dense
                                  hide-details="auto"
                                  :rules="status == 'see' ? [] : rules_select"
                                  :readonly="status == 'see'"
                                  color="#00A99D"
                                  class="mt-1 mr-5"
                                >
                                  <template slot="label">
                                    <span class="font-16 text-000000">สมัคร(1B531)</span>
                                  </template>
                                </v-checkbox>

                                <v-checkbox
                                  v-model="data.over15.program_regis"
                                  value="false"
                                  dense
                                  hide-details="auto"
                                  :rules="status == 'see' ? [] : rules_select"
                                  :readonly="status == 'see'"
                                  color="#00A99D"
                                  class="mt-1 mr-5"
                                >
                                  <template slot="label">
                                    <span class="font-16 text-000000">ไม่สมัคร</span>
                                  </template>
                                </v-checkbox>
                              </v-row>

                              <v-row v-else no-gutters>
                                <span v-if="data.over15.program_regis == 'true'" class="pt-2 font-16 text-000000">สมัคร(1B531)</span>
                                <span v-else-if="data.over15.program_regis == 'false'" class="pt-2 font-16 text-000000">ไม่สมัคร</span>
                                <span v-else class="pt-2 font-16 text-000000">-</span>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-row>

          <v-row :class="display_vuetify == 'xs' ? 'mt-5 mb-8 pb-0 px-1':'my-5 px-5 py-0'" style="border: 5px solid #00A99D;">
            <v-row class="ma-0">
              <v-col cols="12" class="d-flex d-flex-row pr-0 pl-2 pb-3">
                <v-row no-gutters>
                  <v-col cols="12" xl="6" lg="6" class="d-flex d-flex-row pb-3">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">สาเหตุความพิการ</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-checkbox
                        v-model="data.disability.cause_disability.answer_title"
                        value="โดยกำเนิด"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                        @click="data.disability.cause_disability.status = '1'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">โดยกำเนิด</span>
                        </template>
                      </v-checkbox>

                      <v-row no-gutters class="ma-0">
                        <v-col cols="12" class="d-flex d-flex-row pb-3">
                          <v-checkbox
                            v-model="data.disability.cause_disability.answer_title"
                            value="โดยโรค"
                            dense
                            hide-details="auto"
                            :rules="status == 'see' ? [] : rules_select"
                            :readonly="status == 'see'"
                            color="#00A99D"
                            class="mt-1 mr-5"
                            @click="data.disability.cause_disability.status = '2'"
                          >
                            <template slot="label">
                              <span class="font-16 text-000000">โดยโรค</span>
                            </template>
                          </v-checkbox>

                          <v-row v-if="data.disability.cause_disability.answer_title == 'โดยโรค'" no-gutters>
                            <v-text-field
                              dense
                              solo
                              hide-details="auto"
                              v-model="data.disability.cause_disability.more_answer_title"
                              :rules="status == 'see' ? [] : rules_input"
                              :readonly="status == 'see'"
                              class="mr-2"
                            >
                              <template slot="label">
                                <span class="font-14">กรุณากรอกข้อมูล</span>
                              </template>
                            </v-text-field>
                          </v-row>
                        </v-col>
                      </v-row>

                      <v-row no-gutters class="ma-0">
                        <v-col cols="12" class="d-flex d-flex-row pb-3">
                          <v-checkbox
                            v-model="data.disability.cause_disability.answer_title"
                            value="โดยอุบัติเหตุ"
                            dense
                            hide-details="auto"
                            :rules="status == 'see' ? [] : rules_select"
                            :readonly="status == 'see'"
                            color="#00A99D"
                            class="mt-1 mr-5"
                            @click="data.disability.cause_disability.status = '3'"
                          >
                            <template slot="label">
                              <span class="font-16 text-000000">โดยอุบัติเหตุ</span>
                            </template>
                          </v-checkbox>

                          <v-row v-if="data.disability.cause_disability.answer_title == 'โดยอุบัติเหตุ'" no-gutters>
                            <v-text-field
                              dense
                              solo
                              hide-details="auto"
                              v-model="data.disability.cause_disability.more_answer_title"
                              :rules="status == 'see' ? [] : rules_input"
                              :readonly="status == 'see'"
                              class="mr-2"
                            >
                              <template slot="label">
                                <span class="font-14">กรุณากรอกข้อมูล</span>
                              </template>
                            </v-text-field>
                          </v-row>
                        </v-col>
                      </v-row>

                      
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000" style="white-space: nowrap;">: {{ data.disability.cause_disability.answer_title || '-' }}</span>
                      <span v-if="data.disability.cause_disability.more_answer_title" class="pt-2 mx-3 font-16 text-000000" style="white-space: nowrap;">ระบุ : {{ data.disability.cause_disability.more_answer_title || '-' }}</span>
                    </v-row>
                  </v-col>
                  
                  <v-col cols="12" xl="6" lg="6" class="d-flex d-flex-row pb-3">
                    <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ระดับความรุนแรง</span>
                    <v-row v-if="status !== 'detail'" no-gutters>
                      <v-checkbox
                        v-model="data.disability.severity_level.answer_title"
                        value="ช่วยตัวเองได้"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                        @click="data.disability.severity_level.status = '1'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">ช่วยตัวเองได้</span>
                        </template>
                      </v-checkbox>

                      <v-checkbox
                        v-model="data.disability.severity_level.answer_title"
                        value="ควรให้ความช่วยเหลือ"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                        @click="data.disability.severity_level.status = '2'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">ควรให้ความช่วยเหลือ</span>
                        </template>
                      </v-checkbox>

                      <v-checkbox
                        v-model="data.disability.severity_level.answer_title"
                        value="ช่วยเหลือด่วน"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                        @click="data.disability.severity_level.status = '3'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">ช่วยเหลือด่วน</span>
                        </template>
                      </v-checkbox>

                      <v-checkbox
                        v-model="data.disability.severity_level.answer_title"
                        value="หายจากความพิการ"
                        dense
                        hide-details="auto"
                        :rules="status == 'see' ? [] : rules_select"
                        :readonly="status == 'see'"
                        color="#00A99D"
                        class="mt-1 mr-5"
                        @click="data.disability.severity_level.status = '4'"
                      >
                        <template slot="label">
                          <span class="font-16 text-000000">หายจากความพิการ</span>
                        </template>
                      </v-checkbox>
                    </v-row>

                    <v-row v-else no-gutters>
                      <span class="pt-2 font-16 text-000000" style="white-space: nowrap;">: {{ data.disability.severity_level.answer_title || '-' }}</span>
                    </v-row>
                  </v-col>


                  <v-col cols="12" class="d-flex d-flex-row">
                    <v-row no-gutters>
                      <v-col cols="12" xl="3" lg="3" md="6" sm="6" class="d-flex d-flex-row pb-3">
                        <span class="mr-2 pt-2 font-16 text-000000" :style="display_vuetify == 'xs' ? '' : 'white-space: nowrap;'">ประเภทความพิการ</span>

                        <v-row v-if="status !== 'detail'" no-gutters>
                          <v-text-field
                            dense
                            solo
                            hide-details="auto"
                            v-model="data.disability.type_disability"
                            :rules="status == 'see' ? [] : rules_input"
                            :readonly="status == 'see'"
                            class="mr-2"
                          >
                            <template slot="label">
                              <span class="font-14">กรุณากรอกประเภทความพิการ</span>
                            </template>
                          </v-text-field>
                        </v-row>

                        <v-row v-else no-gutters>
                          <span class="pt-2 font-16 text-000000" style="white-space: nowrap;">: {{ data.disability.type_disability || '-' }}</span>
                        </v-row>
                      </v-col>

                      <v-col cols="12" xl="3" lg="3" md="6" sm="6" class="d-flex d-flex-row pb-3">
                        <span class="mr-2 pt-2 font-16 text-000000" :style="display_vuetify == 'xs' ? '' : 'white-space: nowrap;'">วันเริ่มพิการ</span>

                        <v-row v-if="status !== 'detail'" no-gutters>
                          <v-menu
                            v-model="day_menu7"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="350px"
                            min-width="auto"
                            bottom
                            left
                            :disabled="status == 'see'"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                solo
                                dense
                                append-icon="mdi-calendar-multiselect"
                                :value="displayDate7()"
                                v-bind="attrs"
                                hide-details
                                v-on="on"
                                color="#00A99D"
                                item-color="teal darken-2"
                                :rules="status == 'see' ? [] : rules_input"
                                :readonly="status == 'see'"
                                class="mx-3"
                              >
                                <template slot="append">
                                  <v-btn text icon width="10px" v-on="on" :readonly="status == 'see'">
                                    <v-icon color="#00A99D"
                                      >mdi-calendar-multiselect</v-icon
                                    >
                                  </v-btn>
                                </template>

                                <template slot="label">
                                  <span class="font-14">วัน/เดือน/ปี เริ่มพิการ</span>
                                </template>
                              </v-text-field>
                            </template>
                            <v-date-picker
                              v-model="data.disability.disability_date"
                              :max="dateNow"
                              no-title
                              scrollable
                              locale="th"
                              @input="day_menu7 = false"
                              color="#00A99D"
                              ref="picker"
                              :readonly="status == 'see'"
                            >
                              <v-spacer></v-spacer>
                              <v-btn text color="#00A99D" @click="clearDaySelect7"
                                >ล้างค่า/clear</v-btn
                              >
                            </v-date-picker>
                          </v-menu>
                        </v-row>

                        <v-row v-else no-gutters>
                          <span class="pt-2 font-16 text-000000" style="white-space: nowrap;">: {{ showDate(data.disability.disability_date) || '-' }}</span>
                        </v-row>
                      </v-col>
                      
                      <v-col cols="12" xl="3" lg="3" md="6" sm="6" class="d-flex d-flex-row pb-3">
                        <span class="mr-2 pt-2 font-16 text-000000" :style="display_vuetify == 'xs' ? '' : 'white-space: nowrap;'">วันบัตรพิการหมดอายุ</span>

                        <v-row v-if="status !== 'detail'" no-gutters>
                          <v-menu
                            v-model="day_menu8"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="350px"
                            min-width="auto"
                            bottom
                            left
                            :disabled="status == 'see'"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                solo
                                dense
                                append-icon="mdi-calendar-multiselect"
                                :value="displayDate8()"
                                v-bind="attrs"
                                hide-details
                                v-on="on"
                                color="#00A99D"
                                item-color="teal darken-2"
                                :rules="status == 'see' ? [] : rules_input"
                                :readonly="status == 'see'"
                                class="mx-3"
                              >
                                <template slot="append">
                                  <v-btn text icon width="10px" v-on="on" :readonly="status == 'see'">
                                    <v-icon color="#00A99D"
                                      >mdi-calendar-multiselect</v-icon
                                    >
                                  </v-btn>
                                </template>

                                <template slot="label">
                                  <span class="font-14">วัน/เดือน/ปี บัตรพิการหมดอายุ</span>
                                </template>
                              </v-text-field>
                            </template>
                            <v-date-picker
                              v-model="data.disability.disabled_card_expired"
                              no-title
                              scrollable
                              locale="th"
                              @input="day_menu8 = false"
                              color="#00A99D"
                              ref="picker"
                              :readonly="status == 'see'"
                            >
                              <v-spacer></v-spacer>
                              <v-btn text color="#00A99D" @click="clearDaySelect8"
                                >ล้างค่า/clear</v-btn
                              >
                            </v-date-picker>
                          </v-menu>
                        </v-row>

                        <v-row v-else no-gutters>
                          <span class="pt-2 font-16 text-000000" style="white-space: nowrap;">: {{ showDate(data.disability.disabled_card_expired) || '-' }}</span>
                        </v-row>
                      </v-col>

                      <v-col cols="12" xl="3" lg="3" md="6" sm="6" class="d-flex d-flex-row pb-3">
                        <span class="mr-2 pt-2 font-16 text-000000" :style="display_vuetify == 'xs' ? '' : 'white-space: nowrap;'">ความต้องการความช่วยเหลือ</span>

                        <v-row v-if="status !== 'detail'" no-gutters>
                          <v-text-field
                            dense
                            solo
                            hide-details="auto"
                            v-model="data.disability.need_help"
                            :rules="status == 'see' ? [] : rules_input"
                            :readonly="status == 'see'"
                            class="mr-2"
                          >
                            <template slot="label">
                              <span class="font-14">กรุณากรอกความต้องการความช่วยเหลือ</span>
                            </template>
                          </v-text-field>
                        </v-row>

                        <v-row v-else no-gutters>
                          <span class="pt-2 font-16 text-000000" style="white-space: nowrap;">: {{ data.disability.need_help || '-' }}</span>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" class="d-flex d-flex-row">
                    <v-row no-gutters>
                      <v-col cols="12" xl="6" lg="6" md="6" sm="6" class="d-flex d-flex-row pb-3">
                        <span class="mr-2 pt-2 font-16 text-000000" :style="display_vuetify == 'xs' ? '' : 'white-space: nowrap;'">ปัญหาชีวิตที่เกิดมาจากความพิการ</span>

                        <v-row v-if="status !== 'detail'" no-gutters>
                          <v-text-field
                            dense
                            solo
                            hide-details="auto"
                            v-model="data.disability.life_problems"
                            :rules="status == 'see' ? [] : rules_input"
                            :readonly="status == 'see'"
                            class="mr-2"
                          >
                            <template slot="label">
                              <span class="font-14">กรุณากรอกปัญหาชีวิตที่เกิดมาจากความพิการ</span>
                            </template>
                          </v-text-field>
                        </v-row>

                        <v-row v-else no-gutters>
                          <span class="pt-2 font-16 text-000000" style="white-space: nowrap;">: {{ data.disability.life_problems || '-' }}</span>
                        </v-row>
                      </v-col>

                      <v-col cols="12" xl="6" lg="6" md="6" sm="6" class="d-flex d-flex-row pb-3">
                        <span class="mr-2 pt-2 font-16 text-000000" :style="display_vuetify == 'xs' ? '' : 'white-space: nowrap;'">การช่วยเหลือที่ได้รับ</span>

                        <v-row v-if="status !== 'detail'" no-gutters>
                          <v-text-field
                            dense
                            solo
                            hide-details="auto"
                            v-model="data.disability.help_received"
                            :rules="status == 'see' ? [] : rules_input"
                            :readonly="status == 'see'"
                            class="mr-2"
                          >
                            <template slot="label">
                              <span class="font-14">กรุณากรอกการช่วยเหลือที่ได้รับ</span>
                            </template>
                          </v-text-field>
                        </v-row>

                        <v-row v-else no-gutters>
                          <span class="pt-2 font-16 text-000000" style="white-space: nowrap;">: {{ data.disability.help_received || '-' }}</span>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" class="d-flex d-flex-row">
                    <v-row no-gutters>
                      <v-col cols="12" xl="3" lg="4" class="d-flex d-flex-row pb-3">
                        <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ADL</span>

                        <v-row v-if="status !== 'detail'" no-gutters>
                          <v-checkbox
                            v-model="data.disability.ADL.answer_title"
                            value="ติดสังคม"
                            dense
                            hide-details="auto"
                            :rules="status == 'see' ? [] : rules_select"
                            :readonly="status == 'see'"
                            color="#00A99D"
                            class="mt-1 mr-5"
                            @click="data.disability.ADL.status = '1'"
                          >
                            <template slot="label">
                              <span class="font-16 text-000000">ติดสังคม</span>
                            </template>
                          </v-checkbox>

                          <v-checkbox
                            v-model="data.disability.ADL.answer_title"
                            value="ติดบ้าน"
                            dense
                            hide-details="auto"
                            :rules="status == 'see' ? [] : rules_select"
                            :readonly="status == 'see'"
                            color="#00A99D"
                            class="mt-1 mr-5"
                            @click="data.disability.ADL.status = '2'"
                          >
                            <template slot="label">
                              <span class="font-16 text-000000">ติดบ้าน</span>
                            </template>
                          </v-checkbox>

                          <v-checkbox
                            v-model="data.disability.ADL.answer_title"
                            value="ติดเตียง"
                            dense
                            hide-details="auto"
                            :rules="status == 'see' ? [] : rules_select"
                            :readonly="status == 'see'"
                            color="#00A99D"
                            class="mt-1 mr-5"
                            @click="data.disability.ADL.status = '3'"
                          >
                            <template slot="label">
                              <span class="font-16 text-000000">ติดเตียง</span>
                            </template>
                          </v-checkbox>
                        </v-row>
                        
                        <v-row v-else no-gutters>
                          <span class="pt-2 font-16 text-000000" style="white-space: nowrap;">: {{ data.disability.ADL.answer_title || '-' }}</span>
                        </v-row>
                      </v-col>

                      <v-col cols="12" xl="3" lg="3" md="6" sm="6" class="d-flex d-flex-row pb-3">
                        <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">ชื่อ-สกุล ผู้ดูแล</span>

                        <v-row v-if="status !== 'detail'" no-gutters>
                          <v-text-field
                            dense
                            solo
                            hide-details="auto"
                            v-model="data.disability.caretaker_name"
                            :rules="status == 'see' ? [] : rules_input"
                            :readonly="status == 'see'"
                            class="mr-2"
                          >
                            <template slot="label">
                              <span class="font-14">กรุณากรอกชื่อ-สกุล ผู้ดูแล</span>
                            </template>
                          </v-text-field>
                        </v-row>

                        <v-row v-else no-gutters>
                          <span class="pt-2 font-16 text-000000" style="white-space: nowrap;">: {{ data.disability.caretaker_name || '-' }}</span>
                        </v-row>
                      </v-col>

                      <v-col cols="12" xl="3" lg="3" md="6" sm="6" class="d-flex d-flex-row pb-3">
                        <span class="mr-2 pt-2 font-16 text-000000" style="white-space: nowrap;">เบอร์โทรศัพท์</span>

                        <v-row v-if="status !== 'detail'" no-gutters>
                          <v-text-field
                            dense
                            solo
                            hide-details="auto"
                            v-model="data.disability.mobile"
                            :rules="status == 'see' ? [] : rules_input"
                            :readonly="status == 'see'"
                            class="mr-2"
                            @input="splitDatMobile2()"
                            v-mask="[mask_mobile1, mask_mobile2]"
                          >
                            <template slot="label">
                              <span class="font-14">กรุณากรอกเบอร์โทรศัพท์</span>
                            </template>
                          </v-text-field>
                        </v-row>

                        <v-row v-else no-gutters>
                          <span class="pt-2 font-16 text-000000" style="white-space: nowrap;">: {{ data.disability.mobile || '-' }}</span>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions v-if="status !== 'see' && status !== 'detail'">
        <v-row class="px-5">
          <v-spacer></v-spacer>
          <v-col cols="6" xl="2" lg="3">
            <v-btn block rounded color="#00A99D" depressed outlined @click="saveForm(data, 'draft')">บันทึกฉบับร่าง</v-btn>
          </v-col>
          <v-col cols="6" xl="2" lg="3">
            <!-- <v-btn block rounded color="#00A99D" depressed :disabled="valid == false" class="btn-disabled" @click="saveForm(data, 'finish')">บันทึก</v-btn> -->
            <v-btn block rounded color="#00A99D" depressed dark @click="saveForm(data, 'finish')">บันทึก</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      dialog: false,
      valid: false,
      status: '',
      item: {},
      value: {},
      day_menu: false,
      day_menu2: false,
      day_menu3: false,
      day_menu4: false,
      day_menu5: false,
      day_menu6: false,
      day_menu7: false,
      day_menu8: false,
      dateNow: moment().format("YYYY-MM-DD"),
      mask_id: 'X-XXXX-X####-##-#',
      mask_mobile1: '###-###-####',
      mask_mobile2: '#-####-####',
      mask_houseReg: '####-######-#',
      splitMobile: '',
      splitMobile2: '',
      splitID: '',
      splitID2: '',
      splitID3: '',
      splitID4: '',
      splitID5: '',
      splitHouseReg: '',
      data: {
        house_registration_code: '',
        house_no: '',
        moo: '',
        community_name: '',
        road: '',
        soi: '',
        mobile: '',
        under14: {
          cardnum: '',
          fullname: '',
          birth_date: null,
          blood: '',
          weight: '',
          height: '',
          school: '',
          level: '',
          personal_disease: '',
          allergic_medicine: '',
          religion: {
            detail: '',
            status: '',
            answer_title: '',
          },
          living: {
            status: '',
            answer_title: '',
          },
          father_information: {
            fullname: '',
            cardnum: '',
          },
          mother_information: {
            fullname: '',
            cardnum: '',
          },
          birth_weight: '',
          eat_mother_milk: '',
          around_head: '',
          around_umbilical: '',
          development: {
            month: {
              status: '',
              answer_title: '',
            },
            normality_status: {
              status: '',
              answer_title: '',
            }
          },
          milk_tooth: '',
          real_tooth: '',
          toothless: '',
          gills: '',
          fluoride: '',
          hole_tooth: '',
          vaccine: [ //ข้อมูลวัคซีน
            {
              id: 1,
              vaccine_name: "BCG",
              date: '',
              location: ''
            },
            {
              id: 2,
              vaccine_name: "HBV1",
              date: '',
              location: ''
            },
            {
              id: 3,
              vaccine_name: "DHB+OPV2",
              date: '',
              location: ''
            },
            {
              id: 4,
              vaccine_name: "DHB+OPV2",
              date: '',
              location: ''
            },
            {
              id: 5,
              vaccine_name: "DHB+OPV2",
              date: '',
              location: ''
            },
            {
              id: 6,
              vaccine_name: "MMR1",
              date: '',
              location: ''
            },
            {
              id: 7,
              vaccine_name: "IPV1",
              date: '',
              location: ''
            },
            {
              id: 8,
              vaccine_name: "IPV2",
              date: '',
              location: ''
            },
            {
              id: 9,
              vaccine_name: "MMRS",
              date: '',
              location: ''
            },
            {
              id: 10,
              vaccine_name: "JE1/J11",
              status: 1,
              answer_title: '',
              date: '',
              location: ''
            },
            {
              id: 11,
              vaccine_name: "JE2/J12",
              status: 1,
              answer_title: '',
              date: '',
              location: ''
            },
            {
              id: 12,
              vaccine_name: "JE3/J11",
              status: 1,
              answer_title: '',
              date: '',
              location: ''
            },
            {
              id: 13,
              vaccine_name: "DTP+OPV4",
              date: '',
              location: ''
            },
            {
              id: 14,
              vaccine_name: "MMR2",
              date: '',
              location: ''
            },
            {
              id: 15,
              vaccine_name: "DTP+OPV5",
              date: '',
              location: ''
            },
            {
              id: 16,
              vaccine_name: "dTs4",
              date: '',
              location: ''
            },
            {
              id: 17,
              vaccine_name: "HPVs1",
              date: '',
              location: ''
            },
            {
              id: 18,
              vaccine_name: "HPVs2",
              date: '',
              location: ''
            }
          ],
        },
        pregnant_woman: {
          cardnum: '',
          fullname: '',
          birth_date: null,
          blood: '',
          weight: '',
          height: '',
          BP1: '',
          P: '',
          BP2: '',
          DTX: {
            detail: '',
            status: '',
            answer_title: '',
          },
          personal_diseases: '',
          allergy_medicine: '',
          history_pregnancy: {
            pregnancy_times: '',
            place_birth: '',
            how_to_birth: '',
            age_pregnancy: '',
            LPM: '',
            EDC: '',
            place_prenatal_care: ''
          },      
        },
        over15: {
          cardnum: '',
          fullname: '',
          birth_date: '',
          blood: '',
          weight: '',
          height: '',
          around_waist: '',
          around_hips: '',
          allergy_medicine: '',
          BP1: '',
          P: '',
          BP2: '',
          DTX: {
            detail: '',
            status: '',
            answer_title: '',
          },
          religion: {
            detail: '',
            status: '',
            answer_title: '',
          },
          person_status: {
            status: '',
            answer_title: '',
          },
          birth_control: {
            status: '',
            answer_title: '',
          },
          living: {
            status: '',
            answer_title: '',
          },
          breast_cancer: {
            status: '',
            inspection_date: null,
            inspection_location: '', 
            last_inspection_result: '', 
          },
          colon_cancer: {
            status: '',
            inspection_date: '', 
            inspection_location: '', 
            last_inspection_result: '', 
          },
          cervical_cancer: {
            status: '', 
            inspection_date: '', 
            inspection_location: '', 
            last_inspection_result: '', 
          },
          GPA_last: '',
          LMP: '',
          information_depression: {
            status: '',
            answer_title: '',
            subanswer_title_1: {
              status: '',
              answer_title: '',
            },
            subanswer_title_2: {
              status: '',
              answer_title: '',
            },
          },
          cigarette_screening: {
            history: {
              status: '',
              answer_title: '',
              more_answer_title: ''
            },
            smoke_after_wakeup: {
              status: '',
              answer_title: '',
            },
            tracking: {
              status: '',
              answer_title: '',
            },
            amount_smoking: {
              status: '',
              answer_title: '',
            },
            program_regis: '',
          },
        },
        disability: {
          cause_disability: {
            status: '',
            answer_title: '',
            more_answer_title: '',
          },
          severity_level: {
            status: '',
            answer_title: '',
          },
          type_disability: '',
          disability_date: null,
          disabled_card_expired: null, 
          need_help: '',
          life_problems: '',
          help_received: '',
          ADL: {
            status: '',
            answer_title: '',
          },
          caretaker_name: '',
          mobile: '',
        },
      },
      rules_input: [(v) => !!v || "กรุณากรอกข้อมูล"],
      rules_input_num: [(v) => !!v || "กรุณากรอกข้อมูล", (v) => /^([0-9])+$/.test(v) || "กรอกได้เฉพาะตัวเลข"],
      rules_select: [(v) => !!v || "กรุณาเลือกข้อมูล"],
    }
  },
  computed: {
    display_vuetify() {
      return this.$vuetify.breakpoint.name
    },
  },
  methods: {
    openDialog(item, value, status) {
      // console.log('item', item);
      // console.log('status', status);
      this.status = status
      this.item = item
      this.value = value

      this.splitMobile = ''
      this.splitMobile2 = ''
      this.splitID = ''
      this.splitID2 = ''
      this.splitID3 = ''
      this.splitID4 = ''
      this.splitID5 = ''
      this.splitHouseReg = ''

      this.dialog = true
      if (status !== 'see') {
        this.getDataForm()
      }

      this.mask_id = 'X-XXXX-X####-##-#'
      this.mask_mobile1 = '###-###-####'
      this.mask_mobile2 = '#-####-####'
      this.mask_houseReg = '####-######-#'
    },
    async getDataForm() {
      try {
        var params = new URLSearchParams()
        params.append('template_id', this.value.template_id)
        params.append('biz_id', sessionStorage.getItem('biz_id'))
        params.append('userqr_id', this.item.userqr_id || '')
         
        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/get_home_visits_byid?${params}` ,
        ).then(async (res) => {
          // console.log('get data',res);
          if (res.data.result == "success" && res.data.code == 200) {
            if ('formDisabledPerson' in res.data.data) {
              this.data = res.data.data.formDisabledPerson

              if(res.data.data.formDisabledPerson.house_registration_code) {
                this.data.house_registration_code = res.data.data.formDisabledPerson.house_registration_code
                  if(res.data.data.formDisabledPerson.house_registration_code.length == 11) {
                    this.data.house_registration_code = res.data.data.formDisabledPerson.house_registration_code.slice(0, 4)+'-'+
                                                        res.data.data.formDisabledPerson.house_registration_code.slice(4, 10)+'-'+
                                                        res.data.data.formDisabledPerson.house_registration_code.slice(10, 11)
                  }
              }

              if(res.data.data.formDisabledPerson.mobile.length == 9) {
                this.data.mobile = res.data.data.formDisabledPerson.mobile.slice(0, 1)+'-'+
                                   res.data.data.formDisabledPerson.mobile.slice(1, 5)+'-'+
                                   res.data.data.formDisabledPerson.mobile.slice(5, 9)
              } else if(res.data.data.formDisabledPerson.mobile.length == 10) {
                this.data.mobile = res.data.data.formDisabledPerson.mobile.slice(0, 3)+'-'+
                                   res.data.data.formDisabledPerson.mobile.slice(3, 6)+'-'+
                                   res.data.data.formDisabledPerson.mobile.slice(6, 10)
              }

              if(res.data.data.formDisabledPerson.disability.mobile.length == 9) {
                this.data.disability.mobile = res.data.data.formDisabledPerson.disability.mobile.slice(0, 1)+'-'+
                                              res.data.data.formDisabledPerson.disability.mobile.slice(1, 5)+'-'+
                                              res.data.data.formDisabledPerson.disability.mobile.slice(5, 9)
              } else if(res.data.data.formDisabledPerson.disability.mobile.length == 10) {
                this.data.disability.mobile = res.data.data.formDisabledPerson.disability.mobile.slice(0, 3)+'-'+
                                              res.data.data.formDisabledPerson.disability.mobile.slice(3, 6)+'-'+
                                              res.data.data.formDisabledPerson.disability.mobile.slice(6, 10)
              }

              //view => เหลือ format cid
              if (res.data.data.formDisabledPerson.under14.cardnum) {
                if (res.data.data.formDisabledPerson.under14.cardnum.length == 13) {
                  this.data.under14.cardnum = res.data.data.formDisabledPerson.under14.cardnum.slice(0, 1) + '-' +
                  res.data.data.formDisabledPerson.under14.cardnum.slice(1, 5) + '-' +
                  res.data.data.formDisabledPerson.under14.cardnum.slice(5, 10) + '-' +
                  res.data.data.formDisabledPerson.under14.cardnum.slice(10, 12) + '-' +
                  res.data.data.formDisabledPerson.under14.cardnum.slice(12, 14)
                }
              }

              if(res.data.data.formDisabledPerson.under14.father_information.cardnum) {
                if (res.data.data.formDisabledPerson.under14.father_information.cardnum.length == 13) {
                  this.data.under14.father_information.cardnum = res.data.data.formDisabledPerson.under14.father_information.cardnum.slice(0, 1) + '-' +
                  res.data.data.formDisabledPerson.under14.father_information.cardnum.slice(1, 5) + '-' +
                  res.data.data.formDisabledPerson.under14.father_information.cardnum.slice(5, 10) + '-' +
                  res.data.data.formDisabledPerson.under14.father_information.cardnum.slice(10, 12) + '-' +
                  res.data.data.formDisabledPerson.under14.father_information.cardnum.slice(12, 14)
                }
              }

              if(res.data.data.formDisabledPerson.under14.mother_information.cardnum) {
                if (res.data.data.formDisabledPerson.under14.mother_information.cardnum.length == 13) {
                  this.data.under14.mother_information.cardnum = res.data.data.formDisabledPerson.under14.mother_information.cardnum.slice(0, 1) + '-' +
                  res.data.data.formDisabledPerson.under14.mother_information.cardnum.slice(1, 5) + '-' +
                  res.data.data.formDisabledPerson.under14.mother_information.cardnum.slice(5, 10) + '-' +
                  res.data.data.formDisabledPerson.under14.mother_information.cardnum.slice(10, 12) + '-' +
                  res.data.data.formDisabledPerson.under14.mother_information.cardnum.slice(12, 14)
                }
              }

              if(res.data.data.formDisabledPerson.pregnant_woman.cardnum) {
                if (res.data.data.formDisabledPerson.pregnant_woman.cardnum.length == 13) {
                  this.data.pregnant_woman.cardnum = res.data.data.formDisabledPerson.pregnant_woman.cardnum.slice(0, 1) + '-' +
                  res.data.data.formDisabledPerson.pregnant_woman.cardnum.slice(1, 5) + '-' +
                  res.data.data.formDisabledPerson.pregnant_woman.cardnum.slice(5, 10) + '-' +
                  res.data.data.formDisabledPerson.pregnant_woman.cardnum.slice(10, 12) + '-' +
                  res.data.data.formDisabledPerson.pregnant_woman.cardnum.slice(12, 14)
                }
              }

              if(res.data.data.formDisabledPerson.over15.cardnum) {
                if (res.data.data.formDisabledPerson.over15.cardnum.length == 13) {
                  this.data.over15.cardnum = res.data.data.formDisabledPerson.over15.cardnum.slice(0, 1) + '-' +
                  res.data.data.formDisabledPerson.over15.cardnum.slice(1, 5) + '-' +
                  res.data.data.formDisabledPerson.over15.cardnum.slice(5, 10) + '-' +
                  res.data.data.formDisabledPerson.over15.cardnum.slice(10, 12) + '-' +
                  res.data.data.formDisabledPerson.over15.cardnum.slice(12, 14)
                }
              }
            }
          }
        })
      } catch(error) {
        console.log('error',error);
      }
    },
    showDate(item) {
      if (item !== '' && item !== null && item !== undefined) {
        var year1 = ""
        var year2 = ""
        year1 = moment(item).locale("th").format("YYYY")
        year2 = (parseInt(year1) + 543).toString()
        return moment(item).locale("th").format("D/MM/" + year2)
      } else {
        return '-'
      }
    },
    displayDate() {
      var year1 = ""
      var year2 = ""
      if (!this.data.under14.birth_date) return;
        year1 = moment(this.data.under14.birth_date).locale("th").format("YYYY")
        year2 = (parseInt(year1) + 543).toString()
        return moment(this.data.under14.birth_date).locale("th").format("DD/MM/" + year2)
    },
    clearDaySelect() {
      this.data.under14.birth_date = null;
      this.day_menu = false;
    },
    displayDate1(index) {
      // console.log(index);
      var year1 = ""
      var year2 = ""
      if (!this.data.under14.vaccine[index].date) return;
      year1 = moment(this.data.under14.vaccine[index].date).locale("th").format("YYYY")
      year2 = (parseInt(year1) + 543).toString()
      return moment(this.data.under14.vaccine[index].date).locale("th").format("D/MM/" + year2)
    },
    displayDate2() {
      var year1 = ""
      var year2 = ""
      if (!this.data.pregnant_woman.birth_date) return;
        year1 = moment(this.data.pregnant_woman.birth_date).locale("th").format("YYYY")
        year2 = (parseInt(year1) + 543).toString()
        return moment(this.data.pregnant_woman.birth_date).locale("th").format("DD/MM/" + year2)
    },
    clearDaySelect2() {
      this.data.pregnant_woman.birth_date = null;
      this.day_menu2 = false;
    },
    displayDate3() {
      var year1 = ""
      var year2 = ""
      if (!this.data.over15.birth_date) return;
        year1 = moment(this.data.over15.birth_date).locale("th").format("YYYY")
        year2 = (parseInt(year1) + 543).toString()
        return moment(this.data.over15.birth_date).locale("th").format("DD/MM/" + year2)
    },
    clearDaySelect3() {
      this.data.over15.birth_date = null;
      this.day_menu3 = false;
    },
    displayDate4() {
      var year1 = ""
      var year2 = ""
      if (!this.data.over15.breast_cancer.inspection_date) return;
        year1 = moment(this.data.over15.breast_cancer.inspection_date).locale("th").format("YYYY")
        year2 = (parseInt(year1) + 543).toString()
        return moment(this.data.over15.breast_cancer.inspection_date).locale("th").format("DD/MM/" + year2)
    },
    clearDaySelect4() {
      this.data.over15.breast_cancer.inspection_date = null;
      this.day_menu4 = false;
    },
    displayDate5() {
      var year1 = ""
      var year2 = ""
      if (!this.data.over15.colon_cancer.inspection_date) return;
        year1 = moment(this.data.over15.colon_cancer.inspection_date).locale("th").format("YYYY")
        year2 = (parseInt(year1) + 543).toString()
        return moment(this.data.over15.colon_cancer.inspection_date).locale("th").format("DD/MM/" + year2)
    },
    clearDaySelect5() {
      this.data.over15.colon_cancer.inspection_date = null;
      this.day_menu5 = false;
    },
    displayDate6() {
      var year1 = ""
      var year2 = ""
      if (!this.data.over15.cervical_cancer.inspection_date) return;
        year1 = moment(this.data.over15.cervical_cancer.inspection_date).locale("th").format("YYYY")
        year2 = (parseInt(year1) + 543).toString()
        return moment(this.data.over15.cervical_cancer.inspection_date).locale("th").format("DD/MM/" + year2)
    },
    clearDaySelect6() {
      this.data.over15.cervical_cancer.inspection_date = null;
      this.day_menu6 = false;
    },
    displayDate7() {
      var year1 = ""
      var year2 = ""
      if (!this.data.disability.disability_date) return;
        year1 = moment(this.data.disability.disability_date).locale("th").format("YYYY")
        year2 = (parseInt(year1) + 543).toString()
        return moment(this.data.disability.disability_date).locale("th").format("DD/MM/" + year2)
    },
    clearDaySelect7() {
      this.data.disability.disability_date = null;
      this.day_menu7 = false;
    },
    displayDate8() {
      var year1 = ""
      var year2 = ""
      if (!this.data.disability.disabled_card_expired) return;
        year1 = moment(this.data.disability.disabled_card_expired).locale("th").format("YYYY")
        year2 = (parseInt(year1) + 543).toString()
        return moment(this.data.disability.disabled_card_expired).locale("th").format("DD/MM/" + year2)
    },
    clearDaySelect8() {
      this.data.disability.disabled_card_expired = null;
      this.day_menu8 = false;
    },
    closeDialog() {
      this.valid = false

      if (this.status !== 'see' && this.status !== 'detail') {
        this.$refs.save_form.resetValidation();
      } 

      this.dialog = false
      this.status = ''
      this.item = {}
      this.value = {}
      this.day_menu = false
      this.day_menu2 = false
      this.day_menu3 = false
      this.day_menu4 = false
      this.day_menu5 = false
      this.day_menu6 = false
      this.day_menu7 = false
      this.day_menu8 = false
      this.dateNow = moment().format("YYYY-MM-DD"),
      this.splitMobile = ''
      this.splitMobile2 = ''
      this.splitID = ''
      this.splitID2 = ''
      this.splitID3 = ''
      this.splitID4 = ''
      this.splitID5 = ''
      this.splitHouseReg = ''

      this.mask_id = ''
      this.mask_mobile1 = ''
      this.mask_mobile2 = ''
      this.data = {
        house_registration_code: '',
        house_no: '',
        moo: '',
        community_name: '',
        road: '',
        soi: '',
        mobile: '',
        under14: {
          cardnum: '',
          fullname: '',
          birth_date: null,
          blood: '',
          weight: '',
          height: '',
          school: '',
          level: '',
          personal_disease: '',
          allergic_medicine: '',
          religion: {
            detail: '',
            status: '',
            answer_title: '',
          },
          living: {
            status: '',
            answer_title: '',
          },
          father_information: {
            fullname: '',
            cardnum: '',
          },
          mother_information: {
            fullname: '',
            cardnum: '',
          },
          birth_weight: '',
          eat_mother_milk: '',
          around_head: '',
          around_umbilical: '',
          development: {
            month: {
              status: '',
              answer_title: '',
            },
            normality_status: {
              status: '',
              answer_title: '',
            }
          },
          milk_tooth: '',
          real_tooth: '',
          toothless: '',
          gills: '',
          fluoride: '',
          hole_tooth: '',
          vaccine: [ //ข้อมูลวัคซีน
            {
              id: 1,
              vaccine_name: "BCG",
              date: '',
              location: ''
            },
            {
              id: 2,
              vaccine_name: "HBV1",
              date: '',
              location: ''
            },
            {
              id: 3,
              vaccine_name: "DHB+OPV2",
              date: '',
              location: ''
            },
            {
              id: 4,
              vaccine_name: "DHB+OPV2",
              date: '',
              location: ''
            },
            {
              id: 5,
              vaccine_name: "DHB+OPV2",
              date: '',
              location: ''
            },
            {
              id: 6,
              vaccine_name: "MMR1",
              date: '',
              location: ''
            },
            {
              id: 7,
              vaccine_name: "IPV1",
              date: '',
              location: ''
            },
            {
              id: 8,
              vaccine_name: "IPV2",
              date: '',
              location: ''
            },
            {
              id: 9,
              vaccine_name: "MMRS",
              date: '',
              location: ''
            },
            {
              id: 10,
              vaccine_name: "JE1/J11",
              status: 1,
              answer_title: '',
              date: '',
              location: ''
            },
            {
              id: 11,
              vaccine_name: "JE2/J12",
              status: 1,
              answer_title: '',
              date: '',
              location: ''
            },
            {
              id: 12,
              vaccine_name: "JE3/J11",
              status: 1,
              answer_title: '',
              date: '',
              location: ''
            },
            {
              id: 13,
              vaccine_name: "DTP+OPV4",
              date: '',
              location: ''
            },
            {
              id: 14,
              vaccine_name: "MMR2",
              date: '',
              location: ''
            },
            {
              id: 15,
              vaccine_name: "DTP+OPV5",
              date: '',
              location: ''
            },
            {
              id: 16,
              vaccine_name: "dTs4",
              date: '',
              location: ''
            },
            {
              id: 17,
              vaccine_name: "HPVs1",
              date: '',
              location: ''
            },
            {
              id: 18,
              vaccine_name: "HPVs2",
              date: '',
              location: ''
            }
          ],
        },
        pregnant_woman: {
          cardnum: '',
          fullname: '',
          birth_date: null,
          blood: '',
          weight: '',
          height: '',
          BP1: '',
          P: '',
          BP2: '',
          DTX: {
            detail: '',
            status: '',
            answer_title: '',
          },
          personal_diseases: '',
          allergy_medicine: '',
          history_pregnancy: {
            pregnancy_times: '',
            place_birth: '',
            how_to_birth: '',
            age_pregnancy: '',
            LPM: '',
            EDC: '',
            place_prenatal_care: ''
          },      
        },
        over15: {
          cardnum: '',
          fullname: '',
          birth_date: '',
          blood: '',
          weight: '',
          height: '',
          around_waist: '',
          around_hips: '',
          allergy_medicine: '',
          BP1: '',
          P: '',
          BP2: '',
          DTX: {
            detail: '',
            status: '',
            answer_title: '',
          },
          religion: {
            detail: '',
            status: '',
            answer_title: '',
          },
          person_status: {
            status: '',
            answer_title: '',
          },
          birth_control: {
            status: '',
            answer_title: '',
          },
          living: {
            status: '',
            answer_title: '',
          },
          breast_cancer: {
            status: '',
            inspection_date: null,
            inspection_location: '', 
            last_inspection_result: '', 
          },
          colon_cancer: {
            status: '',
            inspection_date: '', 
            inspection_location: '', 
            last_inspection_result: '', 
          },
          cervical_cancer: {
            status: '', 
            inspection_date: '', 
            inspection_location: '', 
            last_inspection_result: '', 
          },
          GPA_last: '',
          LMP: '',
          information_depression: {
            status: '',
            answer_title: '',
            subanswer_title_1: {
              status: '',
              answer_title: '',
            },
            subanswer_title_2: {
              status: '',
              answer_title: '',
            },
          },
          cigarette_screening: {
            history: {
              status: '',
              answer_title: '',
              more_answer_title: ''
            },
            smoke_after_wakeup: {
              status: '',
              answer_title: '',
            },
            tracking: {
              status: '',
              answer_title: '',
            },
            amount_smoking: {
              status: '',
              answer_title: '',
            },
            program_regis: '',
          },
        },
        disability: {
          cause_disability: {
            status: '',
            answer_title: '',
            more_answer_title: '',
          },
          severity_level: {
            status: '',
            answer_title: '',
          },
          type_disability: '',
          disability_date: null,
          disabled_card_expired: null, 
          need_help: '',
          life_problems: '',
          help_received: '',
          ADL: {
            status: '',
            answer_title: '',
          },
          caretaker_name: '',
          mobile: '',
        }
      }
    },
    async saveForm(data, status) {
        this.$swal({
        title: "<span style='color: #000000;font-size: 20px;font-family: Sarabun;font-weight: 700;'>ท่านต้องการยืนยันบันทึกข้อมูลนี้ใช่หรือไม่ ?</span>",
        icon: "question",
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText:
          "<span style='color: #F5222D;font-size: 16px;font-family: Sarabun, sans-serif'>ยกเลิก</span>",
        cancelButtonColor: "#FFFFFF",
        showConfirmButton: true,
        confirmButtonText:
          "<span style='font-size: 16px;font-family: Sarabun, sans-serif;'>ยืนยัน</span>",
        confirmButtonColor: "#00A99D",
        allowOutsideClick: false,
      }).then(async(result) => {
        if (result.isConfirmed) {
          // console.log('data', data);
          // console.log('status', status);
          // if (!this.$refs.save_form.validate() && status == 'finish') {
          //   this.$swal({
          //     title:
          //       "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>กรุณากรอกข้อมูลให้ครบถ้วน</span>",
          //     icon: "error",
          //     showCloseButton: false,
          //     showConfirmButton: false,
          //     background: "white",
          //     timer: 3000,
          //   });
          // } else {

            try {
              var params = new URLSearchParams()
              params.append('account_id', sessionStorage.getItem("account_id"))
              params.append('biz_id', sessionStorage.getItem('biz_id'))
              params.append('template_id', this.value.template_id)
              params.append('appointment_id', this.item.appointment_id)
              params.append('actions_type', status || '')

              this.splitMobile = ''
              this.splitDatMobile()
              data.mobile = this.splitMobile

              this.splitMobile2 = ''
              this.splitDatMobile2()
              data.disability.mobile = this.splitMobile2

              this.splitID = ''
              this.splitDatID('id')
              data.under14.cardnum = this.splitID

              this.splitID2 = ''
              this.splitDatID('id2')
              data.under14.father_information.cardnum = this.splitID2

              this.splitID3 = ''
              this.splitDatID('id3')
              data.under14.mother_information.cardnum = this.splitID3

              this.splitID4 = ''
              this.splitDatID('id4')
              data.pregnant_woman.cardnum = this.splitID4

              this.splitID5 = ''
              this.splitDatID('id5')
              data.over15.cardnum = this.splitID5

              this.splitHouseReg = ''
              this.splitDatHouseReg()
              data.house_registration_code = this.splitHouseReg

              await this.axios.post(`${process.env.VUE_APP_BACKEND_URL}/v1/update_template_home_visit?${params}`, 
                {
                  formDisabledPerson: data
                }
              ).then((res) => {
                // console.log('res3333333333333333', res);
                if (res.data.result == "success" && res.data.code == 200) {
                  this.$swal({
                    icon: "success",
                    title: "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>บันทึกข้อมูลสำเร็จ</span>",
                    showConfirmButton: false,
                  }).then(() => {
                    this.closeDialog()
                    this.$emit("close");
                    this.$emit("status_type", status)
                  })
                } else {
                  this.$swal({
                    icon: "error",
                    title:"<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดพลาด</span>",
                    html: "<span style='color: black;font-size: 16px;font-family: Sarabun, sans-serif;'>เนื่องจาก " + res.data.message + "</span>",
                    showConfirmButton: false,
                  }).then(() => {
                    this.closeDialog();
                    this.$emit("close");
                  });
                }
              })
            } catch (err) {
              console.log(err);
            }
          // }
        }   
      })
    },
    splitDatHouseReg() {
      if (this.data.house_registration_code) {
        this.splitHouseReg = this.data.house_registration_code.replaceAll("-", "")
      }
    },
    splitDatMobile() {
      if(this.data.mobile.length == 11) {
        var xx = this.data.mobile.split('-')
        this.splitMobile = xx[0]+xx[1]+xx[2]
      } else if(this.data.mobile.length == 12) {
        var zz = this.data.mobile.split('-')
        this.splitMobile = zz[0]+zz[1]+zz[2]
      }
    },
    splitDatMobile2() { 
      if(this.data.disability.mobile.length == 11) {
        var x2 = this.data.disability.mobile.split('-')
        this.splitMobile2 = x2[0]+x2[1]+x2[2]
      } else if(this.data.disability.mobile.length == 12) {
        var z2 = this.data.disability.mobile.split('-')
        this.splitMobile2 = z2[0]+z2[1]+z2[2]
      }
    },
    splitDatID(type) {
      if(type == 'id') {
        if(this.data.under14.cardnum) {
          this.splitID = this.data.under14.cardnum.replaceAll("-", "")
        }
      } else if(type == 'id2') {
        if(this.data.under14.father_information.cardnum) {
          this.splitID2 = this.data.under14.father_information.cardnum.replaceAll("-", "")
        }
      } else if(type == 'id3') {
        if(this.data.under14.mother_information.cardnum) {
          this.splitID3 = this.data.under14.mother_information.cardnum.replaceAll("-", "")
        }
      } else if(type == 'id4') {
        if(this.data.pregnant_woman.cardnum) {
          this.splitID4 = this.data.pregnant_woman.cardnum.replaceAll("-", "")
        }
      } else if(type == 'id5') {
        if(this.data.over15.cardnum) {
          this.splitID5 = this.data.over15.cardnum.replaceAll("-", "")
        }
      }
    },
  },
}
</script>

<style scoped>
::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}

::v-deep .btn-disabled.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  color: #333333 !important;
}
</style>